export default {
  vi: {
    components: {
      jDataTable: {
        showing: 'Đang xem',
        to: 'đến',
        of: 'trong tổng số',
        perPageText: 'Số mục hiển thị mỗi trang',
        entries: 'mục',
        goToText: 'Chuyển đến trang',
      },
      daterangepicker: {
        tooltipDefault: 'Khoảng thời gian được chọn không quá 90 ngày',
      },
      latestOrders: {
        title: 'Chi tiết đơn',
        order: 'Đơn',
        commission: 'Hoa hồng',
        status: 'Trạng thái',
        date: 'Thời gian',
        approved: 'Thành công',
        rejected: 'Đã huỷ',
        pending: 'Chờ duyệt',
        emptyTable: {
          topContent: 'Không có thông tin',
          bottomContent: 'Đơn mới nhất sẽ hiển thị tại đây ngay khi được ghi nhận'
        }
      },
      vsInputCopy: {
        copy: 'Sao chép',
      },
      flexibleSelect: {
        all: 'Tất cả',
        selected: 'được chọn',
        notFound: 'Không tìm thấy kết quả'
      },
      reportService: {
        all: 'Tất cả',
        conversionPending: 'Chờ duyệt',
        conversionSuccess: 'Thành công',
        conversionCancel: 'Đã hủy',
        invoiceNoProcess: 'Chưa thanh toán',
        invoiceSuccess: 'Đã thanh toán',
        invoiceProcessing: 'Đang xử lý',
      },
      carerH: {
        accountManager: 'Account Manager Hỗ trợ',
        supportText: 'Nếu bạn cần hỗ trợ, vui lòng liên hệ AM',
        workingTime: 'Thứ 2 - Thứ 6 | 09:00 - 18:00',
        contact: 'Chat với AM',
        zalo: 'Liên hệ qua Zalo OA',
        fb: 'Liên hệ qua Fanpage',
        contactHelp: 'Liên hệ hỗ trợ',
        urgentNote: 'Nếu cần hỗ trợ gấp/ngoài giờ,'
      },
      modalRating: {
        error: 'Vui lòng chọn <b>Mức độ hài lòng</b>, <b>góp ý</b> và <b>ý kiến đánh giá</b> của bạn',
        title: 'Hãy đánh giá HyperLead!',
        subtitle: 'Chọn mức độ hài lòng của bạn',
        feedbackTitle: 'Bạn muốn góp ý về: (có thể chọn nhiều)',
        ui: 'Giao diện',
        ux: 'Trải nghiệm',
        feature: 'Tính năng',
        support: 'Hỗ trợ',
        submit: 'Gửi',
        thankTitle: 'Cảm ơn bạn đã đánh giá',
        thankSubtitle: 'Chúng tôi sẽ cố gắng hoàn thiện sản phẩm hơn trong tương lai. <br/> (Tự động tắt sau 3s)',
      },
      browseAdvertisementDialog: {
        title: "Cách chạy Affiliate",
        topDescription: "Bạn vui lòng cung cấp cho HyperLead thông tin về Cách chạy Affiliate của bạn nhé!",
        choose: "Chọn tại đây",
        addOtherType: "Thêm Cách chạy khác",
        create: "Tạo mới",
        delete: "Xoá",
      },
      filterAffSub: {
        label: "Lọc theo Aff_sub",
        addFilterAffSub: "Thêm bộ lọc Aff_sub",
        remove: "Ẩn bớt",
      },
      policyModal: {
        header: "Chính sách bảo vệ dữ liệu cá nhân",
        body: "Để trao đổi thông tin và sử dụng các dịch vụ của HyperLead, người dùng cần xác nhận rằng đã đọc và hiểu <a class='policy-modal__link' href='/privacy-policy' target='_blank'>Chính sách bảo mật</a> này; và đồng ý chấp thuận việc HyperLead sử dụng, xử lý và chuyển giao Thông tin Cá nhân của người dùng như bên dưới.",
        save: "HyperLead được phép lưu trữ và xử lý dữ liệu cá nhân cơ bản của tôi",
        purpose: "Tôi đã được thông báo rõ ràng về mục đích sử dụng dữ liệu cá nhân từ HyperLead",
        permission: "Tôi có toàn quyền quyết định với dữ liệu cá nhân của mình",
        submit: "CHẤP THUẬN"
      }
    },
    global: {
      justNow: 'vừa xong',
      justNowTime: 'vài giây trước',
      ago: 'trước',
      second: 'giây',
      minute: 'phút',
      hour: 'giờ',
      day: 'ngày',
      week: 'tuần',
      month: 'tháng',
      year: 'năm',
      seeMore: 'Xem thêm',
      dateRange: 'Khoảng ngày',
      success: 'Thành công',
      pending: 'Chờ duyệt',
      rejected: 'Huỷ',
      search: 'Tìm kiếm',
      all: 'Tất cả',
      cancel: 'Huỷ',
      info: 'Thông báo',
      error: 'Lỗi',
      warning: 'Cảnh báo',
      copySuccess: 'Sao chép thành công!',
      copyError: 'Sao chép lỗi',
      total: 'Tổng',
      errorOccured: 'Đã có lỗi xảy ra',
      updateSuccess: 'Cập nhật thành công',
      serverError: 'Không thể kết nối đến server',
      noMatching: 'Chưa có dữ liệu phù hợp',
      noMatch: 'Chưa có dữ liệu',
      keywordForSearch: 'Nhập từ khoá tìm kiếm...',
      apply: "Áp dụng"
    },
    router: {
      home: 'Trang chủ',
      userProfile: 'Thông tin cá nhân',
      userProfilePayment: 'Thông tin tài khoản',
      offer: 'Chiến dịch',
      offerInfo: 'Chiến dịch',
      news: 'Tin tức & Sự kiện',
      newsDetail: 'Bài viết',
      tools: 'Công cụ',
      createdLink: 'Link đã tạo',
      parkingDomain: 'Parking Domain',
      masofferAPI: "HyperLead's API",
      postback: 'Postback',
      addPostback: 'Thêm Postback',
      editPostback: 'Sửa Postback',
      report: 'Báo cáo',
      orderReport: 'Báo cáo chiến dịch',
      orderReportDetail: 'Báo cáo đơn hàng',
      performanceReport: 'Báo cáo hiệu quả',
      revenueReport: 'Báo cáo doanh thu',
      pay: 'Thanh toán',
      paymentHistory: 'Lịch sử thanh toán',
      invoiceDetail: 'Chi tiết',
      loyalty: 'Ưu đãi thành viên',
      support: 'Hỗ trợ',
      termsAndConditions: 'Quy định & Chính sách',
      aboutMasOffer: 'Về HyperLead',
      faq: 'Câu hỏi thường gặp',
      paymentFAQ: 'Thanh toán & Hoa hồng',
      linkFAQ: 'Link phân phối',
      accountFAQ: 'Tài khoản',
      offerFAQ: 'Offer (Chiến dịch)',
      ticketManage: 'Ticket',
      ticketCreate: 'Ticket',
      ticketDetail: 'Ticket',
      knowledgeBase: 'Kiến thức cơ bản',
      knowledgeCategory: 'Kiến thức cơ bản',
      knowledgePost: 'Kiến thức cơ bản',
      login: 'Đăng nhập',
      register: 'Tạo tài khoản',
      findConversion: 'Tra cứu đơn',
      hyperleadWrapped: 'Tổng kết năm',
      hyperleadWrappedResult: 'Kết quả của bạn'
    },
    verifyOtp: {
      submit: 'Tiếp tục',
      loading: 'Đang gửi',
    },
    login: {
      warning: 'Lưu ý',
      validateFormRegister: 'Vui lòng hoàn thành biểu mẫu đăng ký',
      title: 'Đăng nhập',
      welcomeMessage: 'Chào mừng trở lại, hãy đăng nhập bằng tài khoản của bạn',
      username: 'Tên đăng nhập / Email',
      password: 'Mật khẩu',
      rememberMe: 'Ghi nhớ đăng nhập',
      forgetPassword: 'Quên mật khẩu?',
      register: 'Tạo tài khoản',
      login: 'Đăng nhập',
      or: 'Hoặc',
      and: ' và ',
      loginWithGoogle: 'Đăng nhập với Google',
      loginWithDemo: 'Đăng nhập Demo',
      registerSuccessTitle: 'Đăng ký thành công!',
      registerSuccessText: 'Bạn vui lòng kiểm ra Email để kích hoạt tài khoản, nếu không có vui lòng check hòm thư Spam!',
      areYouNotHaveAnAccount: 'Bạn chưa có tài khoản? ',
      areYouHaveAnAccount: 'Bạn đã có tài khoản?',
      loginNow: 'Đăng nhập',
      letCreateAccount: 'Tạo tài khoản mới',
      acceptTermsQuote: 'Bằng việc đăng ký tài  khoản, bạn đã đồng ý với ',
      termsAndConditions: ' Điều khoản & Điều kiện',
      // policy
      privacyPolicy: 'Chính sách bảo mật',
      ourAbout: ' của chúng tôi',
      requireVerifyEmailDesc:
        '<b>7 ngày</b> kể từ thời điểm đăng ký sử dụng dịch vụ của chúng tôi. <br/>\n            Vui lòng <b>xác thực email</b> tài khoản của bạn để tiếp tục trải nghiệm dịch vụ của Hyperlead. <br/><br/>\n            Nếu bạn chưa tìm thấy email xác thực từ hệ thống, vui lòng kiểm tra mục Spam (Thư rác)',
      requireVerifyEmailButton: 'Gửi yêu cầu xác thực email.',
    },
    register: {
      title: 'Tạo tài khoản mới',
      intro: 'Hoàn thành các thông tin để tạo tài khoản mới.',
      fullName: 'Tên đầy đủ',
      firstName: 'Tên',
      lastName: 'Họ',
      userName: 'Tên đăng nhập',
      phoneNumber: 'Số điện thoại',
      campaign: 'Chiến dịch',
      password: 'Mật khẩu',
      confirmPassword: 'Nhập lại mật khẩu',
      termsConditionsAgree: 'Tôi đồng ý với điều khoản và điều kiện',
      enterpriseName: 'Tên doanh nghiệp',
      representativeName: 'Tên người đại diện',
      position: 'Chức vụ hiện tại',
      question: 'Vui lòng chọn loại tài khoản',
      personalTab: 'Cá nhân',
      enterpriseTab: 'Doanh nghiệp',
      descriptionTextPassword:
        'Mật khẩu bắt buộc phải có ít nhất 8 kí tự và có ít nhất 1 chữ HOA, 1 chữ thường, 1 chữ số và có thể có kí tự đặc biệt.',
      authInfo: {
        title: 'Thông tin xác thực',
        intro: 'Mã xác thực sẽ được gửi đến số điện thoại',
        changePhone: 'Đổi số điện thoại',
        zaloReceive: 'Nhận OTP qua Zalo',
        smsReceive: 'Nhận OTP qua SMS',
        btnNext: 'Tiếp theo'
      },

    },
    forgetPassword: {
      title: 'Quên mật khẩu',
      intro: 'Nhập thông tin để nhận hướng dẫn lấy lại mật khẩu',
      recoverPassword: 'Gửi hướng dẫn',
      checkEmail: 'Hướng dẫn khôi phục mật khẩu đã được gửi đến hộp thư của bạn',
      emailNotExists: 'Email không tồn tại, kiểm tra lại thông tin hoặc',
      registerNow: 'Đăng ký ngay',
    },
    authVerify: {
      activatingAccount: 'Đang kích hoạt tài khoản',
      successfulTitle: 'Xác thực thành công',
      successfulDescription: 'Sẽ chuyển sang trang đăng nhập sau 3 giây.',
      errorTitle: 'Xác thực thất bại',
      errorDescription: 'Vui lòng kiểm tra lại mã xác thực của bạn. <br /> Chúng tôi sẽ điều hướng đăng nhập sau 5 giây.',
    },
    resetPassword: {
      title: 'Tạo mật khẩu mới',
      intro: 'Nhập mật khẩu mới để đăng nhập tài khoản của bạn',
      reset: 'Tạo mật khẩu',
      password: 'Mật khẩu',
      confirmPassword: 'Nhập lại mật khẩu',
    },
    authError: {
      1000: 'Chưa chấp nhận điều khoản',
      1001: 'Người dùng đã tồn tại! Vui lòng thử lại.',
      1002: 'Gửi thành công.',
      1003: 'Email không tồn tại',
      1004: 'Thành công! Hãy trở lại trang đăng nhập',
      1005: 'Tài khoản không tồn tại',
      1006: 'Thông tin đăng nhập sai hoặc tài khoản chưa được xác nhận',
      1007: 'Tài khoản đã bị cấm!',
      1008: 'Mật khẩu xác nhận không chính xác',
      1009: 'Địa chỉ Email đã tồn tại',
      password: 'Mật khẩu mới bắt buộc nhập',
      confirmPassword: 'Mật khẩu xác nhận bắt buộc nhập',
    },
    topbar: {
      theme: 'Chủ đề',
      dark: 'Tối',
      light: 'Sáng',
      account: 'Tài khoản',
      logout: 'Đăng xuất',
      notification: 'Thông báo',
      newNotification: 'thông báo mới',
      markAllAsRead: 'Đánh dấu đã đọc',
      am: 'Thông tin hỗ trợ',
      noRank: "Chưa có xếp hạng",
      categoryNotification: {
        all: 'Tất cả',
        preferential: 'Ưu đãi',
        commission: 'Hoa hồng',
        campaign: 'Chiến dịch',
        other: 'Khác'
      }
    },
    footer: {},
    daterangepicker: {
      today: 'Hôm nay',
      yesterday: 'Hôm qua',
      last7days: '7 ngày gần đây',
      last30days: '30 ngày gần đây',
      thisMonth: 'Tháng này',
      lastMonth: 'Tháng trước',
      thisQuarter: 'Quý này',
      lastQuarter: 'Quý trước',
    },
    sidebar: {
      new: 'Mới',
      dashboard: 'Trang chủ',
      offer: 'Chiến dịch',
      news: 'Tin tức & Sự kiện',
      pay: 'Thanh toán',
      commissionsRevenue: 'Doanh thu',
      paymentHistory: 'Lịch sử thanh toán',
      memberOffer: 'Ưu đãi thành viên',
      tool: 'Công cụ',
      createdLinks: 'Link đã tạo',
      report: 'Báo cáo',
      orderReport: 'Báo cáo chiến dịch',
      orderReportDetail: 'Báo cáo đơn hàng',
      performanceReport: 'Báo cáo hiệu quả',
      revenueReport: 'Báo cáo doanh thu',
      support: 'Hỗ trợ',
      termsConditions: 'Quy định & Chính sách',
      aboutMasOffer: 'Về HyperLead',
      faq: 'Câu hỏi thường gặp',
      payment: 'Thanh toán & Hoa hồng',
      trackingLink: 'Link đã tạo',
      account: 'Tài khoản',
      campaign: 'Offer (Chiến dịch)',
      ticketManage: 'Ticket',
      ticketCreate: 'Gửi ticket',
      knowledgeBase: 'Kiến thức cơ bản',
      findConversion: 'Tra cứu đơn',
      hot: 'HOT',
      hyperleadWrapped: "Tổng kết năm"
    },
    affsub: {
      affsub1: 'Aff_sub1',
      affsub1Placeholder: 'VD: google, facebook, tiktok,...',
      affsub2: 'Aff_sub2',
      affsub2Placeholder: 'VD: cpc, ads, banner,...',
      affsub3: 'Aff_sub3',
      affsub3Placeholder: 'VD: the-tin-dung, vay-sinh-vien,...',
      affsub4: 'Aff_sub4',
      affsub4Placeholder: 'VD: ngay-10-10, giam-lai-suat,...',
    },
    home: {
      autoUpdate: 'Tự động cập nhật',
      noUpdate: 'Không cập nhật',
      autoUpdateOn: 'Đã bật tự động cập nhật sau mỗi',
      autoUpdateOff: 'Đã tắt tự động cập nhật',
      successConversionsTotal: 'Số đơn thành công',
      conversionsTotal: 'Số đơn',
      successCommission: 'Doanh thu thành công',
      pendingCommission: 'Hoa hồng chờ duyệt',
      rejectedConversion: 'Hoa hồng hủy',
      news: 'Tin tức đặc biệt',
      moNews: 'Tin tức HyperLead',
      moPromotions: 'Khuyến mãi',
      latestOrders: 'Đơn mới nhất',
      updateNotice: 'UPDATE CHỨNG MINH THƯ & THÔNG TIN THANH TOÁN!',
      dearPub: 'Publisher thân mến,',
      pleaseUpdate: 'Để đảm bảo nhận được thanh toán đúng thời hạn, các bạn vui lòng cập nhật đầy đủ ',
      IDCardInfo: 'Thông tin Chứng minh thư,',
      paymentInfo: 'Thông tin thanh toán',
      contactAM: 'và liên hệ Account Manager của bạn để xác thực thông tin.',
      bestRegards: 'Trân trọng!',
      clicks: 'Số click',
      viewReport: 'Xem báo cáo',
      todayRevenue: 'Doanh thu hôm nay',
      overviewText: 'Tổng quan',
      revenueWeekText: 'Doanh thu tuần',
      revenueMonthText: 'Doanh thu tháng',
      welcome: 'Chào mừng bạn',
      welcomeQuotes: 'Hãy xem qua các chỉ số phía dưới để gia tăng hiệu quả nhé!',
      cvrTooltip: 'Tỷ lệ chuyển đổi = Số đơn thành công / Số click x 100.',
      epcTooltip: 'Thu nhập trên mỗi Click = Doanh thu thành công / Số click',
      dateRangeToolTip: 'Khoảng thời gian chọn phải trong phạm vi 90 ngày kể từ ngày bắt đầu.',
      weekRevenueTooltip: 'Từ Thứ 2 đến Chủ nhật của tuần hiện tại',
      monthRevenueTooltip: 'Từ ngày 1 đến ngày cuối cùng (30 hoặc 31) của tháng hiện tại',
      monday: 'Thứ hai',
      tuesday: 'Thứ ba',
      wednesday: 'Thứ tư',
      thursday: 'Thứ năm',
      friday: 'Thứ sáu',
      saturday: 'Thứ bảy',
      sunday: 'Chủ nhật',
      chartConversion: 'Đơn',
      chartRevenue: 'Doanh thu',
      newDashboard: {
        switchLabel: 'Giao diện mới',
        popup: {
          title: 'Thử giao diện mới',
          content: 'Ấn vào đây để trải nghiệm Trang chủ mới, thuận tiện hơn cho bạn.',
          button: 'Đã hiểu',
        }
      },
      userOnboarding: {
        banner: {
          title: 'Bạn đang không biết sử dụng trang?',
          btnExit: 'Tôi muốn tự khám phá',
          btnContinue: 'Hướng dẫn tôi'
        },
        step1: {
          title: 'Khi bạn cần hỗ trợ',
          content: 'Bấm vào đây để xem thông tin chuyên viên hỗ trợ của bạn',
        },
        stepFb: {
          title: 'Khi bạn cần chat ngay',
          content: 'Bấm vào đây để liên hệ chuyên viên HyperLead',
        },
        step2: {
          title: 'Đăng ký chạy chiến dịch',
          content: 'Vào mục "Chiến dịch” để đăng ký và tạo link chạy affiliate',
        },
        step3: {
          title: 'Xem các tin tức mới nhất',
          content: 'Vào mục "Tin tức & Sự kiện” để xem các tin mới nhất về giá hoa hồng, thưởng, sự kiện từ HyperLead',
        },
        step4: {
          title: 'Xem báo cáo & đơn',
          content: `Xem "Báo cáo tổng quan” để biết tình hình doanh thu. <br>Xem "Báo cáo đơn hàng” để biết thông tin của từng đơn.`,
        },
        step5: {
          title: 'Tích điểm đổi quà',
          content: 'Đổi các phần quà hấp dẫn tại đây',
        },
        step6: {
          title: 'Thắc mắc và yêu cầu hỗ trợ',
          content: 'Vào đây để đọc các kiến thức cho người mới và gửi yêu cầu hỗ trợ',
        },
        stepMessenger: {
          title: 'Khi bạn cần chat ngay',
          content: "Bấm vào đây để liên hệ chuyên viên HyperLead",
        },
        stepToggle: {
          title: 'Ấn vào đây để xem những tính năng cực hữu ích'
        },
        btnStep: {
          btnExit: 'Thoát',
          btnContinue: 'Tiếp theo',
          btnFinish: 'Hoàn tất',
        },
        rating: {
          title: 'Bạn có thấy hướng dẫn này hữu ích?',
          btnYes: 'Có',
          btnNo: 'Không'
        }
      },
      widget: {
        contentThankYou: 'Cảm ơn bạn đã chia sẻ với HyperLead'
      }
    },
    ekyc: {
      title: 'Cập nhật thông tin định danh',
      remind: 'Tài khoản của bạn chưa cập nhật thông tin định danh. Vui lòng cập nhật để được hưởng đầy đủ quyền lợi từ HyperLead',
      gotoUpdate: 'Đến trang cập nhật',
      instruction: 'Chọn ảnh chính diện, chất lương tốt. Sau đó nhấn tiếp tục',
      contact: 'Nếu bạn cần hỗ trợ thực hiện EKYC, vui lòng liên hệ HyperLead qua',
      continue: 'Tiếp tục'
    },
    offer: {
      unknown: 'Unknown',
      linkAffiliate: 'Link phân phối',
      shortLink: 'Link rút gọn',
      keyword: 'Từ khoá',
      keywordPlaceholder: 'Tìm chiến dịch...',
      category: 'Danh mục',
      specialOffers: 'Phân loại chiến dịch',
      makeLink: 'Tạo link',
      register: 'Đăng ký',
      pending: 'Đang xét duyệt',
      paused: 'Đang tạm dừng',
      locked: 'Khoá',
      commission: 'Hoa hồng',
      conversionTime: 'Thời gian lên đơn',
      requestTitle: 'Đăng ký chạy chiến dịch',
      confirm: 'Đăng ký',
      approvalRate: 'Duyệt thành công',
      sendRequest: 'Gửi yêu cầu',
      sendRequestFailed: 'Bạn đã gửi yêu cầu thất bại, vui lòng thử lại.',
      recentlyCreatedLink: 'Link tạo gần đây',
      updateTime: 'Ngày tạo',
      btnSeeAllLinks: 'Xem tất cả link',
      sectionHot: 'Chiến dịch HOT',
      sectionPopular: 'Chiến dịch phổ biến',
      sectionAnother: 'Chiến dịch khác',
      running: 'Đang chạy',
      unregister: 'Chưa đăng ký',
      advertisementRequired: 'Vui lòng chọn hình thức chạy quảng cáo',
      here: 'tại đây',
      popupTitle: 'Bạn chạy chiến dịch này bằng cách nào?',
      popupDesc:
        'Nếu bạn muốn cung cấp thêm thông tin về cách chạy, vui lòng cung cấp',
      popupNote:
        'Lưu ý: Publisher vui lòng liên hệ khung chat trên trang để được hỗ trợ nếu sau 24h đăng ký vẫn chưa được duyệt!',
      popupDropdownAdvertise: 'Chọn tại đây',
      updatedAt: 'Cập nhật',
      addNewTrafficType: "Thêm cách chạy",
      registrationSuccessfully: "Đăng ký thành công!",
      gotIt: "Tôi đã hiểu",
      userOnboarding: {
        banner: {
          title: 'Bạn biết cách <b>tạo link</b> chưa?',
          btnExit: 'Tôi biết rồi',
          btnContinue: 'Chưa, hướng dẫn tôi'
        },
        campaign: {
          step1: {
            title: 'Bước 1',
            content: `
                        Sau đây bạn sẽ được hướng dẫn tạo link.
                        Đầu tiên, vào mục <span class='font-bold text-primary'>“Chiến dịch”</span>, tìm Chiến dịch muốn chạy, sau đó ấn "Tạo link”
                    `
          },
          step2: {
            title: 'Bước 2',
            content: `
                        Kiểm tra các thông tin như "Tên miền", "Landing Page”. Sau đó ấn "Tạo link”
                    `
          },
          step3: {
            title: 'Bước 3',
            content: `
                        Đọc kỹ "Thông tin điều khoản”. Sau đó ấn "Đồng ý”.
                    `
          },
          step4: {
            title: 'Hoàn tất',
            content: `
                            Dưới đây là link bạn vừa tạo.
                            Ấn vào biểu tượng <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <rect x="0.541992" width="22.9156" height="21.7978" rx="6" fill="url(#pattern0)"/>
                            <defs>
                            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_1762_516368" transform="scale(0.0243902 0.025641)"/>
                            </pattern>
                            <image id="image0_1762_516368" width="41" height="39" xlink:href="data:image/png;base64,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"/>
                            </defs>
                            </svg> để sao chép và bắt đầu đẩy chiến dịch nào!
                    `
          },
        }
      }
    },
    offerInfo: {
      info: 'Thông tin chiến dịch',
      name: 'Tên chiến dịch',
      homepage: 'Trang chủ',
      offerType: 'Loại chiến dịch',
      address: 'Địa chỉ',
      commissionRate: 'Hoa hồng chia sẻ',
      successRate: 'Tỉ lệ thành công',
      conversionTime: 'Thời gian lên đơn TB',
      commissionRule: 'Quy tắc ghi nhận',
      specialNote: 'Lưu ý quan trọng',
      cookieRule: 'Cookies Rules',
      description: 'Mô tả',
      makeLink: 'Tạo link',
      createdLinks: 'Link đã tạo',
      orderReport: 'Báo cáo đơn hàng',
      registrationProcess: 'Quy trình đăng ký',
      promotionalMaterial: 'Tài liệu quảng cáo',
      tips: 'Tips chạy chiến dịch',
    },
    offerGenLink: {
      title: 'Tạo link chiến dịch',
      titleLink: 'Link phân phối',
      encodedLink: 'Link mã hoá',
      chooseSSL: 'Chọn SSL tên miền',
      chooseDomain: 'Tên miền',
      landingPage: 'Landing Page',
      advanced: 'Thông tin thêm',
      customLink: 'Link phân phối rút gọn',
      customLinkError: 'Link tùy chỉnh cho phép định dạng là chữ cái không dấu, số và một số ký tự đặc biệt (_ - . ~)',
      makeLink: 'Tạo Link',
      termsConditions: 'Thông tin điều khoản',
      termsConditionsAgree: 'Đồng ý',
      chooseDomainTooltip: 'Chọn các lựa chọn bên dưới mục "Facebook Traffic” để tránh bị chặn link nếu bạn đang quảng cáo/quảng bá thông qua Facebook',
      landingPageTooltip: 'Lựa chọn phù hợp với hoạt động quảng cáo/quảng bá của bạn. Ví dụ, chọn Landing Page dành cho iOS nếu bạn đang quảng cáo đến người dùng iOS',
      acceptTerms: 'Đồng ý chạy chiến dịch XXX \n Mỗi đơn hàng thành công khi đồng ý chạy chiến dịch XXX, HyperLead sẽ chi trả thêm hoa hồng tùy theo từng đối tác',
      titleLinkTooltip: 'Link phân phối  là một URL được tạo ra để theo dõi hoạt động của người dùng sau khi họ nhấp vào liên kết và đảm bảo ghi nhận hoa hồng tiếp thị cho publisher.',
      customLinkTooltip: 'Link rút gọn là một URL được rút gọn từ link phân phối giúp nó trở nên ngắn gọn và đẹp mắt hơn.'
    },
    news: {
      keyword: 'Từ khóa',
      keywordPlaceholder: 'Ví dụ: atmonline, cash24,...',
      selectOffer: 'Chọn đối tác',
      selectNewType: 'Loại tin',
      all: 'Tất cả',
      offerNew: 'Tin tức offer',
      notice: 'Thông báo',
      promotion: 'Khuyến mãi',
      event: 'Sự kiện',
      search: 'Tìm kiếm',
      noNew: 'Không có tin tức nào',
      special: 'Đặc biệt',
      announcement: 'Thông báo',
      specialNews: 'Tin đặc biệt',
      anotherNews: 'Tin tức khác',
    },
    createdLink: {
      date: 'Ngày tạo link',
      dateTitle: 'Ngày tạo',
      offer: 'Chiến dịch',
      chooseOffer: 'Chọn đối tác',
      advanced: 'Thông tin thêm',
      link: 'Link phân phối',
      toggleColumn: 'Ẩn/hiện cột',
      shortenLink: 'Link rút gọn',
      conversion: 'Đơn hàng',
    },
    parkingDomain: {
      title: 'Hướng dẫn thêm tên miền',
      instruction: 'I. HƯỚNG DẪN',
      step1: '\n                <p class="font-semibold">Bạn muốn tạo link với tên miền của riêng mình?Hãy thực hiện theo các bước hướng dẫn dưới đây nhé.</p> <br/>\n                <p class="font-semibold">Bước 1: Thực hiện trỏ CNAME </p>\n                <p>Truy cập trang quản trị tên miền của bạn, vào cài đặt DNS và trỏ tên miền có dạng <span class="font-semibold">go.{domain của bạn}</span> đến <span class="font-semibold">link.riofintech.net</span></p><br/>\n\n                <p>Ví dụ: Trỏ tên miền go.flead.net đến link.riofintech.net</p>',
      step2: '\n                <p class="font-semibold">Bước 2: Cài đặt SSL cho domain</p>\n                <span>Liên hệ AM để yêu cầu cài đặt SSL cho domain <a href="https://zalo.me/2061415747725636566" target="_blank"><span class="text-primary font-semibold">tại đây.</span></a> Bạn cần cung cấp đẩy đủ 3 file sau: *.key, *.pem, *.crt</span>',
      step3: '\n                <p class="font-semibold">Bước 3: Thêm domain đã trỏ CNAME</p>\n                <p>Sau khi AM thông báo đã cài đặt SSL thành công, nhập tên miền của bạn để hoàn tất kết nối với hệ thống HyperLead <span class="text-primary font-semibold" style="cursor: pointer">tại đây</span></p>',
      step4: '\n                <p class="font-semibold">Bước 4: Tạo link và phân phối với tên miền rất đẹp của bạn!</p>\n                <p>Bạn nhớ kiểm tra xem tên miền của bạn có chuyển hướng đúng không nhé!</p>',

      attention: '\n                <p class="font-semibold text-danger">Lưu ý:</p>\n  <ul class="indented-list text-danger"> <li>Bạn phải sở hữu tên miền của bạn</li><li>Hiện tại, hệ thống chỉ hỗ trợ dạng bản ghi là CNAME, bạn cần trỏ go.{domain của bạn} về link.rofintech.net.</li> </ul>',

      here: 'tại đây',
      addDomain: 'II. THÊM TÊN MIỀN',
      addDomainLabel: 'Tên miền',
      addDomainPlaceholder: 'Ví dụ: go.yourdomain.com',
      addAndCheck: 'Thêm tên miền',
      addedList: 'Tên miền bạn đã thêm',
      add: 'Thêm',
      domainRequired: 'Vui lòng điền tên miền',
      addDNS: 'Thêm DNS Record sau vào domain của bạn',
      error: {
        1020: 'Vui lòng nhập tên miền (domain) của bạn!',
        1021: 'Tên miền không đúng. Vui lòng thử lại!',
        1022: 'Tên miền đã được publisher khác sử dụng. Vui lòng thử lại!',
        1023: 'Bạn đã thêm tên miền này rồi!',
        1024: 'Đã có lỗi xảy ra',
      },
      notFound: 'Bạn chưa thêm tên miền.',
    },
    masofferAPI: {
      title: 'Bạn sử dụng link sau để lấy thông tin tất cả các offer',
      param: 'Tham số',
      isRequired: 'Bắt buộc?',
      required: 'Bắt buộc',
      notRequired: 'Không bắt buộc',
      description: 'Ý nghĩa',
      value: 'Giá trị',
      response: 'Kết quả trả về:',
      success: 'Thành công',
      failed: 'Thất bại',
      offers: 'Chiến dịch',
      conversionTitle: 'Chuyển đổi',
      linkGenerator: {
        copy: 'Sao chép',
        offer: {
          pubId: 'Username của bạn',
          token: 'Token của bạn',
        },
        conversion: {
          publisherId: 'Username của bạn',
          token: 'Token của bạn',
          offerId: 'ID của đối tác',
          keyword: 'Từ khoá tìm kiếm',
          dateFrom: 'Ngày bắt đầu của list conversions. Nếu không điền sẽ lấy 10 ngày trước thời gian hiện tại.',
          dateTo: 'Ngày kết thúc của list conversions. Nếu không điền sẽ lấy 10 ngày sau thời gian hiện tại.',
          page: 'Số trang',
          limit: 'Giới hạn lấy ra',
          statusCode: 'Sử dụng để lọc theo trạng thái',
          rejected: 'Từ chối',
          pending: 'Chờ duyệt',
          success: 'Chấp nhận',
          transactionId: 'Tìm kiếm với mã đơn hàng cụ thể',
        },
      },
      offer: {
        title: 'Các bạn sử dụng link như sau để lấy tất cả các offer:',
      },
      conversion: {
        title: 'Các bạn sử dụng link như sau để lấy conversion:',
      },
    },
    postback: {
      addPostback: 'Thêm Postback',
      guide: 'Xem hướng dẫn',

      stt: 'STT',
      offer: 'Đối tác',
      status: 'Trạng thái',
      createdAt: 'Ngày tạo',
      all: 'Tất cả',
      active: 'Đang bật',
      deactive: 'Đã tắt',
      edit: 'Sửa',
      remove: 'Xoá',
      choosingOffer: 'Vui lòng chọn đối tác',
      choosingActive: 'Vui lòng chọn trạng thái',
      enterYourPostbackFind: 'Nhập postback bạn muốn tìm',
    },
    addPostback: {
      offer: 'Đối tác',
      togglePostback: 'Bật/Tắt Postback',
      active: 'Bật',
      deactive: 'Tắt',
      advanced: 'Tuỳ chỉnh nâng cao',
      successTransaction: 'Đơn hàng thành công',
      pendingTransaction: 'Đơn hàng chờ duyệt',
      rejectedTransaction: 'Đơn hàng đã huỷ',
      errorOccured: 'Đã có lỗi xảy ra',
      noOfferError: 'Bạn chưa chọn Đối tác!',
      headerInvalidJson: 'Request Header sai định dạng JSON, vui lòng kiểm tra lại!',
      invalidSuccessLink: 'Link Postback đơn hàng thành công sai định dạng, vui lòng kiểm tra lại!',
      invalidPendingLink: 'Link Postback đơn hàng chờ duyệt sai định dạng, vui lòng kiểm tra lại!',
      invalidRejectedLink: 'Link Postback đơn hàng huỷ sai định dạng, vui lòng kiểm tra lại!',
      noLink: 'Link postback trống, vui lòng thêm ít nhất 1 link!',
      addSuccess: 'Thêm postback thành công',
      addFailed: 'Thêm lỗi!',
      back: 'Quay lại',
      save: 'Lưu lại',
      placeholder: 'Link postback của bạn',
      user_manual: 'Xem hướng dẫn sử dụng',
    },
    orderReport: {
      daterange: 'Khoảng ngày',
      filterByAccount: 'Lựa chọn tài khoản',
      subUser: 'Tài khoản con',
      orderStatus: 'Trạng thái đơn',
      paymentStatus: 'Trạng thái thanh toán',
      campaignId: 'ID Chiến dịch',
      exportExcel: 'Xuất file Excel',
      currentAccount: 'Tài khoản hiện tại',
      chooseAccount: 'Chọn tài khoản',
      errorOccured: 'Đã có lỗi xảy ra',
      requestFailed: 'Yêu cầu không thành công!',
      requestSuccess: 'Yêu cầu thành công! File đang được tải xuống!',
      requestSuccessDescription: 'Chú ý: Bạn chỉ có thể tải file mỗi 1 phút',
      downloadTimeoutWarning: 'Bạn chỉ có thể tải file mỗi 1 phút. Khoảng thời gian tối đa 90 ngày',
      noData: 'Không có dữ liệu! Xin mời chọn lại',
      downloading: 'Đang tiến hành tải xuống...',
      customReport: 'Tuỳ chỉnh báo cáo',
      customAdvance: 'Tuỳ chỉnh hiển thị',
      reportTuningFilter: 'Chọn để thêm cột tương ứng vào báo cáo bên dưới',
      reportTuningFilterTitle: 'Điều chỉnh báo cáo',
      tutorialChooseOrder: 'Hãy click vào từng dòng để xem chi tiết đơn',
      all: 'Tất cả',
      conversionsTitle: 'Số đơn',
      estimateRevenue: 'DOANH THU ƯỚC TÍNH',
      revenue: 'Doanh thu thực nhận',
      saleAmount: 'Giá trị khoản vay',
      chooseStatus: 'Chọn trạng thái',
      chooseOffer: 'Chọn chiến dịch',
      resetFilter: "Đặt lại Bộ lọc",
      otherLabel: "Khác",
      infoDisplayedBy: "Thông tin hiển thị theo",
      cancelRevenue: "Doanh thu huỷ",
      filterByAffSub: 'Tracking Parameters',
      order: 'ĐƠN HÀNG',
      totalClick: 'TỔNG SỐ CLICK',
      total: 'Tổng',
      approved: 'Thành công',
      rejected: 'Đã huỷ',
      pending: 'Chờ duyệt',
      cvrTooltip: 'Tỷ lệ nhấp vào link tiếp thị và thực hiện đăng ký dịch vụ. CVR = (Số đơn hàng phát sinh / Số click) x 100%.',
      epcTooltip: 'Thu nhập trên mỗi Click = Doanh thu thành công / Số click',
      estimateRevenueTooltip: 'Tổng doanh thu từ các đơn phát sinh, bao gồm chờ duyệt và thành công.',
      totalOrder: 'Tổng số đơn',
      totalSuccessfulOrder: 'Số đơn thành công',
      totalPendingOrder: 'Số đơn chờ duyệt',
      totalCancelOrder: 'Số đơn đã hủy',

      revenueFilter: 'Doanh thu',
      totalRevenue: 'Tổng doanh thu',
      totalSuccessfulRevenue: 'Doanh thu thành công',
      totalPendingRevenue: 'Doanh thu chờ duyệt',
      totalCancelRevenue: 'Doanh thu đã huỷ',
      invoiceNoProcess: 'Chưa thanh toán',
      invoiceSuccess: 'Đã thanh toán',
      invoiceProcessing: 'Đang xử lý',
      otherInfo: "Thông tin khác",
    },
    orderReportDetail: {
      resetFilter: "Đặt lại Bộ lọc",
      tutorialChooseOrder: 'Hãy click vào từng dòng để xem chi tiết đơn',
      daterange: 'Khoảng ngày',
      status: 'Trạng thái',
      otherInfo: 'Thông tin khác',
      findByTransactionID: 'Tìm theo Transaction ID',
      findByConversionID: 'Tìm theo Conversion ID',
      findByClickID: 'Tìm theo Click ID',
      findByAccount: 'Lọc theo tài khoản',
      currentAccount: 'Tài khoản hiện tại',
      chooseAccount: 'Chọn tài khoản',
      subuser: 'Tài khoản con',
      offer: 'Chiến dịch',
      device: 'Thiết bị',
      productName: 'Tên sản phẩm',
      referer: 'Giới thiệu',
      clickURL: 'Link đích',
      errorOccured: 'Đã có lỗi xảy ra',
      totalLabel: 'Tổng số $total mục',
      reportTuningFilterTitle: 'Bộ lọc điều chỉnh báo cáo',
      conversionId: 'ID Đơn',
      campaignId: 'ID chiến dịch',
      clickTime: 'Thời gian click',
      generateTime: 'Thời gian phát sinh',
      paymentStatus: 'Trạng thái thanh toán',
      conversionStatus: 'Trạng thái đơn',
      conversionPubPayout: 'Doanh thu',
      statusMessage: 'Ghi chú',
      productCategory: 'Loại sản phẩm',
      saleAmount: 'Giá trị khoản vay',
      other: 'Khác',
      chooseStatus: 'Chọn trạng thái',
      chooseOffer: 'Chọn chiến dịch',
      exportExcel: 'Xuất file Excel',
      statusUpdatedTime: "Thời gian cập nhật trạng thái"
    },
    performanceReport: {
      filter: 'Bộ lọc',
      daterange: 'Khoảng ngày',
      offer: 'ID chiến dịch',
      chooseOffer: 'Chọn đối tác',
      advanced: 'Tuỳ chỉnh nâng cao',
      viewOptions: 'Lựa chọn hiển thị',
      dailyChart: 'Biểu đồ theo ngày',
      hourlyChart: 'Biểu đồ theo giờ',
      dailyAndHourChartGroup: 'Dữ liệu biểu đồ được tính theo',
      conversion: 'Chuyển đổi',
      commission: 'Hoa hồng',
      daily: 'Theo ngày',
      hourly: 'Theo giờ',
      devicesAndBrowsers: 'Trình duyệt và thiết bị',
      byConversions: 'Theo số đơn hàng',
      byCommissions: 'Theo hoa hồng',
      byDevices: 'Theo thiết bị',
      byBrowsers: 'Theo trình duyệt',
      ratio: 'Tỉ trọng',
      detailsTable: 'Bảng chi tiết',
      detailsTableGroup: 'Dữ liệu bảng được tính theo',
      toggleColumns: 'Ẩn/hiện cột',
      pendingConversion: 'Chuyển đổi chờ duyệt',
      successConversion: 'Chuyển đổi thành công',
      rejectedConversion: 'Chuyển đổi huỷ',
      pendingCommission: 'Hoa hồng chờ duyệt',
      successCommission: 'Hoa hồng thành công',
      rejectedCommission: 'Hoa hồng huỷ',
      total: 'Tổng',
      tooltipChartDay: 'Dữ liệu được tổng hợp theo từng ngày',
      tooltipChartHour: 'Dữ liệu được tổng hợp theo từng giờ',
      exactly: 'Chính xác',
      contain: 'Tương đối',
      reportTuningFilterTitle: 'Bộ lọc điều chỉnh báo cáo',
    },
    revenueReport: {
      fromYear: 'Từ năm',
      toYear: 'Đến năm',
      month: 'Tháng',
      successCommission: 'Hoa hồng thành công (đ)',
      pendingCommission: 'Hoa hồng chờ duyệt (đ)',
      rejectedCommission: 'Hoa hồng huỷ (đ)',
      paid: 'Đã trả (đ)',
      remain: 'Còn lại (đ)',
      total: 'Tổng',
      monthDetails: 'Chi tiết doanh thu tháng',
      generalDetails: 'Chi tiết doanh thu',
      errorOccured: 'Đã có lỗi xảy ra',
    },
    paymentHistory: {
      all: 'Tất cả',
      status: 'Trạng thái',
      pending: 'Đang xử lý',
      completed: 'Hoàn tất',
      createdAt: 'Ngày chốt',
      amount: 'Doanh thu t.toán',
      paymentPeriod: 'Thời gian',
      note: 'Ghi chú',
      details: 'Chi tiết',
      noInvoice: 'Không có invoice nào',
      paymentCategory: 'Loại thanh toán',
      invoiceCreatedDayTooltip: 'Ngày tạo hóa đơn thanh toán',
      invoiceTimeTooltip: 'Thời gian quét tạo hóa đơn/tạm ứng',
      recurringPayments: 'Thanh toán định kỳ',
      advancePayment: 'Tạm ứng',
      noteUpdateTime:
        ' Thời gian đối soát thanh toán sẽ được thực hiện vào ngày cuối cùng của tháng T+1. <br/> \n            Trạng thái sẽ được cập nhật tại trang này. Bạn có thể xem thêm thông tin về thanh toán tại \n            <span class="font-bold">mục FAQ</span>',
    },
    invoiceDetails: {
      invoice: 'Hoá đơn',
      invoiceID: 'Mã hoá đơn',
      invoiceDate: 'Thời gian',
      receiptment: 'Người nhận',
      vimarket: 'Công Ty CP Công nghệ RIO Việt Nam',
      hanoi: 'Trụ sở Hà Nội',
      hanoiAddress: 'Tầng 2, Tòa nhà Ecolife Capitol, 58 Tố Hữu, Phường Mễ Trì, Quận Nam Từ Liêm, Thành phố Hà Nội',
      hcm: 'Văn phòng TP.HCM',
      hcmAddress: '3i Thích Quảng Đức, Phường 3, Quận Phú Nhuận, TP. HCM',
      transactions: 'Số đơn',
      products: 'SỐ MẶT HÀNG',
      commission: 'Tổng doanh thu',
      total: 'Tổng doanh thu',
      paymentMonth: 'Thanh toán tháng',
      note: 'Ghi chú',
      campaign: 'Chiến dịch',
      bank: 'Tài khoản ngân hàng',
      paypal: 'Tài khoản PayPal',
      paymentInfo: 'THÔNG TIN THANH TOÁN',
      paymentType: 'Phương thức thanh toán',
      paymentBankName: 'Tên ngân hàng',
      paymentBranch: 'Chi nhánh',
      paymentAccountHolder: 'Tên chủ tài khoản',
      paymentAccountNumber: 'Số tài khoản',
      paymentAccountCard: 'Số thẻ',
      tax: 'MST'

    },
    loyalty: {
      missionStatus: 'Trạng thái nhiệm vụ',
      currentSessionName: 'Tên mùa giải hiện tại',
      tag: 'Mới',
      mop: 'HPoint',
      rp: 'Điểm xếp hạng',
      unauthorized: 'Oh, no! :( <br/> Chương trình Ưu đãi thành viên đang tạm dừng',
      contactAM: 'Bạn vui lòng đợi nhé! Chúng tôi sẽ trở lại sớm thôi.',
      register: 'Đăng ký',
      congrats: 'Chúc mừng bạn!',
      congratsMsg: 'Bạn đã được tham gia chương trình tích điểm, đổi quà Loyalty!',
      info: 'Thông tin',
      mission: 'Nhiệm vụ',
      reward: 'Đổi quà',
      pointHistory: 'Lịch sử điểm',
      about: 'Giới thiệu & Chính sách',
      currentRank: 'Cấp hiện tại',
      newRankMsg: 'Chúc mừng bạn đã đạt cấp',
      chart: 'Bảng Xếp Hạng',
      rank: 'Hạng',
      account: 'Tài khoản',
      status: 'Trạng thái',
      all: 'Tất cả',
      inProgress: 'Đang thực hiện',
      accomplished: 'Đã hoàn thành',
      accomplished2: 'Hoàn thành, chờ nhận thưởng',
      completed: 'Đã nhận thưởng',
      receiveReward: 'Nhận thưởng',
      noMission: 'Chưa có nhiệm vụ nào',
      bonus: 'Thưởng',
      time: 'Thời gian',
      startTime: 'Thời gian bắt đầu',
      endTime: 'Thời gian kết thúc',
      receiveSuccessTitle: 'Nhận thưởng nhiệm vụ thành công!',
      receiveSuccessText: 'Điểm thưởng đã được cộng thành công',
      receiveFailedTitle: 'Nhận thưởng nhiệm vụ không thành công!',
      receiveFailedText: 'Vui lòng thử lại hoặc liên hệ AM để được hỗ trợ',
      noReward: 'Chưa có quà tặng nào',
      getNow: 'Đổi ngay',
      pending: 'Chờ duyệt',
      redeemHistory: 'Lịch sử đổi quà',
      rewardName: 'Tên quà',
      noRedeem: 'Bạn chưa đổi phần quà nào',
      viewAllHistory: 'Xem tất cả lịch sử',
      redeem: 'Đổi quà',
      redeemInfo: 'Thông tin đổi quà',
      required: '*Bắt buộc điền',
      addressPlaceholder: 'Số nhà, phường, xã,...',
      districtPlaceholder: 'Quận',
      cityPlaceholder: 'Tỉnh/Thành phố',
      note: 'Ghi chú',
      quantity: 'Số lượng',
      notEnoughPoint: 'Bạn không đủ điểm đổi quà',
      redeemConfirm: 'Xác nhận đổi quà',
      requestDate: 'Ngày yêu cầu',
      approveDate: 'Ngày xét duyệt',
      redeemSuccessTitle: 'Nhận thưởng thành công!',
      redeemSuccessText: 'AM đã nhận được yêu cầu của bạn',
      redeemFailedTitle: 'Nhận thưởng thất bại!',
      redeemFailedText: 'Vui lòng thử lại hoặc liên hệ AM để được hỗ trợ',
      filterBySeason: 'Lọc theo mùa',
      index: 'STT',
      type: 'Loại',
      amount: 'Số điểm',
      detail: 'Chi tiết',
      issueDate: 'Ngày phát sinh',
      missionComplete: 'Hoàn thành nhiệm vụ',
      addPoint: 'Điểm cộng',
      minusPoint: 'Điểm trừ',
      rewardPending: 'Chờ duyệt quà',
      rewardApproved: 'Đã duyệt quà',
      rewardRejected: 'Từ chối đổi quà',
      noPointHistory: 'Không tìm thấy lịch sử',
      loyaltyIntro:
        '<p class="normal-title">Giới thiệu & Hướng dẫn về</p><p><span class="normal-title">chương trình </span><span class="blue-title">HyperLead Loyalty</span></p>',
      iHaveRead: 'Tôi đã đọc và đồng ý với ',
      loyaltyTerms: 'Điều kiện và Điều khoản Chương trình Ưu đãi thành viên từ HyperLead',
      is_handling: 'Dữ liệu đang được xử lý',
    },
    accountInfo: {
      save: 'Lưu',
      sendRequest: 'Gửi yêu cầu thay đổi thông tin',
      refresh: 'Đặt lại',
      updateSuccess: 'Cập nhật thành công!',
      updateFailed: 'Cập nhật thất bại!',
      requestSuccess: 'Gửi yêu cầu thành công!',
      requestFailed: 'Gửi yêu cầu thất bại!',
      boxContentRequest: 'Vui lòng liên hệ AM của bạn hoặc gửi Ticket để xác minh lí do và xác nhận thay đổi thông tin',
      btnUpdate: 'Cập nhật thông tin',
      btnSubmitInfo: 'Cập nhật thông tin',
      alertPassedInfo: 'Đủ thông tin thanh toán',
      alertWaitAMConfirm: 'Chờ AM xác nhận',
      alertYouAre: 'Bạn đang có',
      alertRequest: 'yêu cầu',
      alertNotConfirmByManager: 'thay đổi thông tin cá nhân chưa được duyệt!',
      alertAdvertisement:
        "Vui lòng điền chính xác thông tin <span class='font-bold'>Hình thức chạy quảng cáo</span> của bạn để được duyệt chiến dịch nhanh nhất",
      general: {
        title: 'Thông tin chung',
        username: 'Tên đăng nhập',
        firstName: 'Họ',
        lastName: 'Tên',
        enterpriseName: 'Tên doanh nghiệp',
        representativeName: 'Tên người đại diện',
        position: 'Chức vụ hiện tại',
        website: 'Địa chỉ website',
        phoneNumber: 'Số điện thoại',
        phoneError: 'Số điện thoại không đúng định dạng!',
        phoneEmpty: 'Số điện thoại không được bỏ trống!',
        nameEmpty: 'Tên đầy đủ không được bỏ trống!',
        emailVerified: 'Email đã được xác thực',
        emailNotVerify: 'Email chưa xác thực',
        verify: 'Xác thực',
        verified: 'Đã xác thực',
        verifying: 'Chờ xác thực',
        verificationSuccessful: 'Gửi xác thực thành công',
        checkMailbox: 'Vui lòng kiểm tra hộp thư của bạn để xác thực tài khoản',
        // change email
        changeEmail: {
          wrongPassword: 'Mật khẩu không chính xác'
        }
      },
      changePassword: {
        title: 'Mật khẩu',
        oldPassword: 'Nhập mật khẩu',
        newPassword: 'Mật khẩu mới',
        confirmPassword: 'Xác nhận mật khẩu',
        notExists: 'Tài khoản không tồn tại, vui lòng kiểm tra lại',
      },
      changeEmail: {
        title: 'Mật khẩu',
        email: {
          new: "Nhập email mới",
          old: "Email cũ",
        },
        password: 'Nhập mật khẩu',
        wrongPassword: 'Mật khẩu không chính xác',
        save: 'Lưu',
        changeYourEmail: "Thay đổi email",
        infoBelow: "Để thay đổi email, vui lòng nhập tất cả thông tin bên dưới:",
        emailChangeType: {
          placeholder: "Chọn phuong thức xác nhận",
          am: "Gửi yêu cầu thay đổi email đến AM",
          email: "Xác nhận qua email"
        },
        responseAM: {
          line1: "Đã gửi yêu cầu thay đổi email của bạn đến AM. Thời gian AM xác nhận thay đổi là từ 1-2 ngày.",
          line2: "Trong thời gian này, AM có thể liên hệ bạn để thu thập thêm một vài thông tin bảo mật cần thiết."
        },
        ok: "Đã hiểu",
        responseSendEmail: {
          line1: "Email cũ và email mới của bạn vừa nhận được mail yêu cầu xác nhận. Để thay đổi email, vui lòng kiểm tra và nhấn “Xác nhận” ở cả 2 mail.",
          line2: "Nếu bạn không tìm thấy mail từ HyperLead, vui lòng kiểm tra mục Thư rác hoặc Spam.",
          note: "<b>Lưu ý</b>: Link xác nhận chỉ có thời hạn 10 phút. <b>Nếu đăng xuất tài khoản trong khoảng thời gian này, bạn cần thực hiện thao tác thay đổi Email lại từ đầu.</b>",
        },
        close: "Đóng",
        responseVerified: "Chúc mừng! Bạn đã thay đổi Email thành công.",
        responseExpired: "Đã hết thời gian để xác nhận qua email cũ và mới. Để thực hiện lại việc đổi email, vui lòng đóng thông báo này, và thực hiện lại việc thay đổi email trong vòng 10 phút.",
        countDownText: "Thời gian xác nhận email mới còn lại",
        successChangeEmail: {
          title: "Xác nhận thành công",
          content_new: "Bạn đã xác nhận thay đổi Email qua Mail mới thành công. Vui lòng kiểm tra Mail hiện tại và xác nhận để hoàn tất thay đổi Email.",
          content_old: "Bạn đã xác nhận thay đổi Email qua Mail hiện tại thành công. Vui lòng kiểm tra Mail mới và xác nhận để hoàn tất thay đổi Email."
        },
        failedChangeEmail: {
          title: "Không thành công",
          content: "Link xác nhận của không chính xác hoặc đã hết hạn, vui lòng thao tác lấy lại link mới."
        },
        rejectChangeEmail: {
          success: {
            title: "Xác nhận thành công.",
            content: "Bạn đã xác nhận từ chối thay đổi Email. Vui lòng kiểm tra Mail hiện tại và xác nhận để hoàn tất thay đổi Email.",
            changePassword: "Thay đổi mật khẩu"
          },

        },
      },
      info: {
        created_at: 'Ngày tạo tài khoản',
        trafficType: 'Cách chạy chiến dịch',
        title: 'Thông tin định danh',
        campaign: 'Chiến dịch',
        taxNumber: 'Mã số thuế',
        taxPlace: 'XXX XXX XXXX',
        birthDate: 'Ngày sinh',
        cmndNumber: 'Số căn cước công dân',
        cmndPlace: 'XXXX XXXX XXXX',
        cmndName: 'Họ tên trên căn cước công dân',
        cmndNamePlace: 'Ví dụ: Nguyễn Văn A',
        cmndLocation: 'Nơi cấp căn cước công dân',
        cmndLocationPlace: 'Nơi cấp căn cước công dân',
        cmndAddress: 'Nơi thường trú trên CCCD',
        cmndAddressPlace: 'Bạch mai, Hai Bà Trưng, Hà Nội',

        cmndDate: 'Ngày cấp căn cước công dân',
        cmndFront: 'Mặt trước',
        cmndBack: 'Mặt sau',
        imageIdentify: 'Ảnh căn cước công dân',
        permanentAddress: 'Địa chỉ thường trú',
        choosePicture: 'Chọn ảnh',
        chooseOtherPicture: 'Chọn ảnh khác',
        wrongFormatTitle: 'Ảnh sai định dạng!',
        wrongFormatText: 'Vui lòng chọn ảnh có đuôi png, jpg hoặc jpeg',
        bigImageTitle: 'Ảnh quá nặng!',
        bigImageText: 'Vui lòng chọn ảnh có kích cỡ < 2MB',
        error: {
          IDNumber: 'Căn cước công dân không thể để trống',
          IDName: 'Căn cước không thể để trống',
          dateOfBirth: 'Ngày sinh không thể để trống',
          IDWhere: 'Vui lòng nhập nơi cấp CCCD',
          dateOfID: 'Vui lòng nhập ngày cấp CCCD',
          imageF: 'Vui lòng tải lên ảnh CCCD (mặt trước)',
          imageB: 'Vui lòng tải lên ảnh CCCD (mặt sau)',
        },
      },
      advertisement: {
        title: 'Hình thức quảng cáo',
        trafficType: 'Nguồn Traffic',
        childrenTrafficType: 'Hình thức quảng cáo',
        description: 'Thông tin chi tiết',
        url: 'Đường dẫn',
        image: 'Hình ảnh',
        action: 'Thêm hình thức',
        close: 'Đóng',
        maximumFilesSelectMessage: 'Tổng số ảnh đang chọn và đã chọn lớn hơn số lượng cho phép',
        maxFileSizeMessage: 'Kích thước tệp __FILENAME__ được chọn lớn hơn kích thước cho phép là __SIZE__',
        advertisementEmptyMessage:
          "<p>Hiện bạn chưa cập nhật hình thức quảng cáo nào, <br/> Vui lòng chọn <span class='text-primary font-semibold'>“Thêm hình thức”</span> để cập nhật.</p>",
        form: {
          trafficType: 'Nguồn Traffic',
          trafficTypePlaceholder: 'Chọn nguồn Traffic',
          childrenTrafficType: 'Hình thức quảng cáo',
          childrenTrafficTypePlaceholder: 'Chọn hình thức quảng cáo',
          description: 'Thông tin chi tiết',
          descriptionPlaceholder: 'Nhập thông tin hình thức quảng cáo',
          url: 'Đường dẫn',
          urlPlaceholder: 'Ví dụ https://www.abc.com/xyz',
          image: 'Hình ảnh',
          delete: 'Xoá',
          action: 'Lưu hình thức',
          actionSaveImage: 'Chọn ảnh',
          limitMessage: 'Chỉ cho phép chọn tối đa 2 hình ảnh',
          noOptionsChildrenTrafficType: "<p>Hãy chọn <span class='font-semibold'>Nguồn traffic</span> trước</p>",
        },
      },
      payment: {
        title: 'Thông tin thanh toán',
        topNotice:
          ' Đây là thông tin thanh toán doanh thu bạn nhận từ HyperLead. \n                Nếu sai thông tin, bạn sẽ không được thanh toán. <br/> \n                Lưu ý: Chỉ được chọn 1 phương thức thanh toán.',
        default: 'Chọn làm phương thức mặc định (Chỉ lưu một phương thức)',
        bank: 'Tài khoản NH nội địa (khuyến khích)',
        paypal: 'Tài khoản PayPal',
        bankAccount: 'Tài khoản ngân hàng',
        bankName: 'Tên ngân hàng',
        bankBranch: 'Chi nhánh (nếu có)',
        bankAccountHolder: 'Tên chủ tài khoản (có dấu)',
        bankAccountNumber: 'Số tài khoản',
        bankAccountCard: 'Số thẻ',
        taxNumber: 'Mã số thuế ',
        postOffice: 'Chuyển bưu điện',
        postOfficeName: 'Bưu điện',
        postOfficeReceiver: 'Người nhận',
        defaultPaymentMethod: "Chọn phương thức thanh toán mặc định",
        defaultPaymentAlert: "Vui lòng chọn phương thức thanh toán",
        error: {
          bankName: 'Tên ngân hàng không thể để trống',
          bankBranch: 'Chi nhánh không thể để trống',
          accountHolder: 'Chủ tài khoản không thể để trống',
          accountNumber: 'Số tài khoản không thể để trống',
          postOffice: 'Tên bưu điện không thể để trống',
          receiver: 'Tên người nhận không thể để trống',
          IDNumber: 'Số CMND không thể để trống',
          dateOfID: 'Ngày cấp không thể để trống',
          placeOfID: 'Nơi cấp không thể để trống',
          email: 'Email không thể để trống',
        },
      },
      social: {
        title: 'Mạng xã hội',
      },
      setting: {
        title: 'Cài đặt',
        notification: 'Thông báo',
        invoiceUpdate: 'Khi có cập nhật hoá đơn',
        newPromotionUpdate: 'Khi có tin tức mã khuyến mại mới',
        commissionUpdate: 'Khi có tin tức cập nhật hoa hồng',
        theme: 'Chủ đề',
        light: 'Sáng',
        dark: 'Tối',
      },
      history: {
        title: 'Lịch sử yêu cầu',
        pending: 'Chờ duyệt',
        approved: 'Đã duyệt',
        rejected: 'Từ chối',
        requestedDate: 'Ngày',
        status: 'Trạng thái',
        changedInfo: 'Thông tin thay đổi',
        tax_code: 'Mã số thuế',
        cmnd: 'Chứng minh nhân dân/Căn cước công dân',
        mobile: 'Số điện thoại',
        email: 'Email',
        payment: 'Thanh toán',
        note: 'Lưu ý: đối với những yêu cầu thay đổi thông tin cá nhân và thanh toán, vui lòng liên hệ AM của bạn hoặc <a href="/support/ticket-create" data-route="ticket-create" class="router-link">gửi Ticket</a> để được chấp nhận!',
      },
      apiToken: {
        publisherKey: 'Dùng với các plugin WordPress HyperLead',
        apiToken: 'Xác thực khi yêu cầu tới API của HyperLead',
      },
      policy: {
        title: 'Bảo mật thông tin',
        headerContent: 'Quyền cho phép xử lý dữ liệu cá nhân',
        content: 'Bằng cách bỏ chọn vào ô bên dưới, bạn sẽ thu hồi sự đồng ý cho phép HyperLead sử dụng, xử lý và chuyển giao dữ liệu của bạn. <br> Lưu ý: Thu hồi sự đồng ý trên sẽ ảnh hưởng đến việc thanh toán hoa hồng, và trải nghiệm của bạn tại HyperLead.',
        contentCheckbox: 'Tôi đồng ý chấp thuận việc HyperLead sử dụng và xử lý Dữ liệu Cá nhân của tôi.',
        submit: 'Xác nhận',
        headerPopup: 'Quyền cho phép xử lý dữ liệu cá nhân',
        contentPopup: 'Thu hồi sự đồng ý trên sẽ <b>ảnh hưởng đến việc thanh toán hoa hồng</b>, và trải nghiệm của bạn tại HyperLead. Bạn có thể sẽ không được thanh toán đúng nếu thu hồi sự cho phép này.',
        areUSure: '<b>Bạn chắc chắn muốn thu hồi chứ?</b>',
        yes: 'Có',
        no: 'Không',
      }
    },
    support: {
      ticket: {
        enterYourTicketFind: 'Nhập ticket bạn muốn tìm',
        answer: 'Trả lời',
        attachFile: 'File đính kém',
        attachment: '(File Đính kèm)',
        attachmentTitle: 'File đính kèm',
        attachmentCondition: 'Giới hạn tải lên {limitedSize}MB',
        attachChooseFile: 'Chọn file tải lên',
        autoCloseInfo: 'Nhân viên hỗ trợ là người phản hồi cuối cùng. Ticket này sẽ tự động đóng sau {hours}.',
        availableFileType: 'Hỗ trợ các định dạng ảnh, video, doc, xls, csv, zip, rar',
        btnClose: 'Đóng ticket',
        btnCreate: 'Tạo mới Ticket',
        btnReOpen: 'Mở lại',
        btnReset: 'Điền lại',
        btnSend: 'Gửi ticket',
        btnSendMessage: 'Gửi trả lời',
        category: 'Danh mục',
        chooseCorrectFormat: 'Vui lòng chọn tệp tin đúng định dạng được phép',
        close: 'Đã đóng',
        closeFailed: 'Lỗi khi đóng ticket',
        closeInfo: 'Bạn vẫn có thể mở lại ticket trong khi gửi phản hồi mới.',
        content: 'Nội dung',
        sidebarTitle: 'Nội dung',
        contentNote1: 'Nội dung súc tích, mạch lạc sẽ giúp ticket của bạn được giải quyết nhanh hơn.',
        contentNote2:
          'Với những yêu cầu báo lỗi mất đơn, sai thông tin đơn, vui lòng điền rõ mã đơn hàng, offer, tracking link và hình ảnh, video đính kèm nếu có.',
        createdAt: 'Thời gian gửi',
        createTitle: 'Thông tin Ticket',
        filesSelected: '({totalFiles} tệp tin được chọn)',
        filesTooLargeTitle: 'Các tệp tin quá lớn!',
        filesTooLarge: 'Dung lượng các tệp tin được chọn quá lớn (>{filesSize}MB)',
        fileWrongType: 'Các tệp tin sai định dạng',
        limitExceeded: 'Tổng các tệp tải lên nhỏ hơn {filesSize}MB',
        infoClose: 'Vui lòng nhấn đóng ticket trong trường hợp vấn đề của bạn đã được giải quyết. Chân thành cảm ơn bạn',
        infoReOpen: 'Bạn vẫn có thể mở lại ticket trong khi gửi phản hồi mới.',
        label: 'Tiêu đề',
        placeholder: 'Vui lòng nhập tiêu đề',
        messagePlaceholder: 'Nhập tin nhắn ...',
        noFileSelected: 'Chưa tệp tin nào được chọn',
        notAllowed: 'Ticket không khả dụng',
        notFound: 'Ticket không tồn tại',
        noticeBeforeClose: 'Ticket này sẽ tự động đóng sau khoảng {daysLeft}{hoursLeft} nữa.',
        open: 'Đang bật',
        processing: 'Đang xử lý ticket của bạn...',
        requiredType: 'Hãy chọn <b>Loại hỗ trợ</b> trước',
        reOpenSuccess: 'Ticket #{ticketID} được mở lại',
        sendMessageFailed: 'Lỗi khi gửi tin nhắn',
        sendSuccess: 'Gửi phiếu yêu cầu thành công',
        spamMessageWarning: 'Vui lòng đợi đến khi nhận được phản hồi từ nhân viên hỗ trợ.',
        status: 'Trạng thái',
        subTitle: 'Gửi ticket khi thực sự cần thiết sẽ giúp chúng mình làm việc năng suất hơn',
        tHeadLastUpdated: 'Lần cập nhật cuối',
        tHeadStatus: 'Trạng thái',
        tHeadTitle: 'Tiêu đề',
        tHeadCategory: 'Danh mục',
        ticketPlaceholder: 'Nhập nội dung mô tả ...',
        title: 'Bạn không có ticket nào đang mở | Bạn có {number} ticket đang mở | Bạn có {number} ticket đang mở',
        titleCreate: 'Ticket #{idTicket} - {titleTicket}',
        type: 'Loại hỗ trợ',
        typeCategory: 'Loại - Danh mục',
        updatedAt: 'Lần cập nhật cuối',
        wrongType: 'Tệp sai định dạng!',
        ticketType: 'Chọn loại hỗ trợ',
        ticketCategory: 'Chọn danh mục',
      },
      findConversion: {
        btnRequestFindConversion: 'Yêu cầu tra cứu',
        filterTitle: 'Lịch sử yêu cầu',
        filterByCampaignId: 'ID chiến dịch',
        filterByProcessStatus: 'Trạng thái xử lý',
        filterByConversionStatus: 'Trạng thái đơn',
        introduce: {
          contentTop: 'Tình trạng thất lạc đơn đang diễn ra ở tất cả các Affiliate Network. Riêng HyperLead, đội ngũ luôn sẵn sàng lắng nghe những góp ý và tìm ra những biện pháp khắc phục dành cho Publisher. Vì vậy, HyperLead triển khai công cụ “TRA CỨU ĐƠN” nhằm giúp Publisher kiểm tra những đơn không hiển thị kết quả trên hệ thống mặc dù đã giới thiệu thành công theo các bước quy định.',
          contentBottom: {
            title: 'Publisher vui lòng lưu ý:',
            listContent: {
              content1: '<span>Vì một số lý do, đơn hàng có thể  <b>hiển thị chậm sau 24h</b></span>',
              content2: '<span>Vui lòng <b>kiểm tra kỹ thông tin</b>, tránh báo trùng đơn</span>',
              content3: '<span>Các trường hợp phát hiện khai báo gian lận sẽ <b>bị khoá tài khoản</b></span>'
            }
          },
        },
        processStatus: {
          hyperLeadReceived: 'Đã tiếp nhận',
          processing: 'Đang xử lý',
          sentToAdvertiser: 'Đã gửi đối tác',
          done: 'Đã xử lý',
        },
        conversionStatus: {
          notStatus: '-',
          cancel: 'Hủy',
          success: 'Thành công'
        },
        table: {
          requestDate: 'Ngày yêu cầu',
          orderId: 'ID Tra Cứu',
          campaignId: 'ID Chiến dịch',
          customerPhone: 'SĐT khách hàng',
          processStatus: 'Trạng thái xử lý',
          conversionStatus: 'Trạng thái đơn',
          estimateRevenue: 'Doanh thu ước tính',
          note: 'Ghi chú',
        },
        popup: {
          title: 'Gửi yêu cầu Tra cứu đơn',
          step1: {
            title: '<span><b>Bước 1/3:</b> Hãy chọn 01 chiến dịch bạn muốn tra cứu đơn</span>',
            placeholderCampaign: 'Nhập tên chiến dịch',
            msgNoResults: 'Không tìm thấy chiến dịch',
            btnContinue: 'Tiếp tục',
          },
          step2: {
            found: {
              title: '<span><b>Bước 2/3:</b>  Đọc kỹ quy trình dưới đây và chắc chắn rằng khách hàng của bạn đã thực hiện đúng.</span>',
              processSignUpCampaignTitle: 'Quy trình đăng ký chiến dịch',
              btnComeback: 'Quay lại',
              btnContinue: 'Tiếp tục',
            },
            notFound: {
              message: 'Rất tiếc, hiện tại chiến dịch này chưa được hỗ trợ tra cứu đơn.',
              btnFindOtherCampaign: 'Tra cứu chiến dịch khác',
              btnExit: 'Thoát'
            }
          },
          step3: {
            title: '<span><b>Bước 3/3:</b>  Hãy nhập thông tin yêu cầu tìm lại đơn</span>',
            inputCampaignLabel: 'Chiến dịch',
            btnComeback: 'Quay lại',
            btnSendRequest: 'Gửi yêu cầu',
            uploadImageLabel: 'Hình ảnh minh chứng (nếu có)',
            btnUploadImage: 'Tải ảnh lên',
            limitRequestNote: '* Bạn có thể thực hiện tối đa 10000 yêu cầu tra cứu đơn trong tháng cho chiến dịch này. Nếu có yêu cầu xử lý gấp với số lượng đơn lớn hơn, vui lòng liên hệ với Account Manager để được hỗ trợ nhanh nhất',
            orderWith: 'Bạn muốn tra cứu theo:',
            singleOrderOffer: 'Tra cứu từng đơn',
            multiPOrderOffer: 'Tra cứu hàng loạt',
            sampleFileNote: 'Tải File mẫu về và điền đầy đủ thông tin trong File. Sau đó tải file lên và chọn ”Gửi yêu cầu"'
          },
          step4: {
            btnComeback: 'Quay lại',
            btnSendRequest: 'Gửi yêu cầu',
            readFileResult: {
              failureTitle: 'KHÔNG THÀNH CÔNG',
              successTitle: 'Kết quả đọc file',
              missingField: 'Cột <b>{column}</b> đang bị thiếu trong file tải lên, vui lòng bổ sung và tải lại',
              onlyCSV: 'Định dạng file không hợp lệ, vui lòng chỉ tải lên file Excel hoặc CSV',
              fileNotValid: 'Tiêu đề cột sai định dạng, vui lòng kiểm tra và tải lên lại',
              offer: 'Chiến dịch: {offer}',
              valid_order: 'Số đơn hợp lệ: {valid_order}',
              invalid_order: 'Số đơn không hợp lệ : {invalid_order}',
              downloadInvalidOffer: 'Tải xuống danh sách không hợp lệ',
              offer_not_found: 'Chiến dịch không tồn tại, vui lòng kiểm tra và tải lên lại',
              file_not_valid: 'Tiêu đề cột sai định dạng, vui lòng kiểm tra và tải lên lại',
              publisher_not_exist: 'Publisher không tồn tại, vui lòng kiểm tra và tải lên lại',
              file_max_record: 'Chỉ cho phép tối đa 10000 dòng trong file, vui lòng kiểm tra và tải lên lại',

            }
          },
          step5: {
            btnComeback: 'Quay lại',
            failureTitle: 'KHÔNG THÀNH CÔNG',
            limitRequest: 'Số lượng yêu cầu vượt quá số lần cho phép, bạn còn {limit} lượt yêu cầu tra cứu đơn trong tháng cho chiến dịch này',
            successTitle: 'GỬI YÊU CẦU THÀNH CÔNG',
            successMessage: `Cảm ơn bạn đã cung cấp thông tin! HyperLead sẽ nỗ lực hết mình trong việc xử lý và cập nhật trạng thái xử lý các đơn lên hệ thống.`,
            btnClose: 'Đóng',
            max_request_per_day: 'Số lượng yêu cầu vượt quá số lần cho phép, bạn còn {limit} lượt yêu cầu tra cứu đơn trong tháng cho chiến dịch này.'
          },
        },
        noData: 'Không có dữ liệu! Xin mời chọn lại',
        downloading: 'Đang tiến hành tải xuống...',
        requestSuccess: 'Yêu cầu thành công! File đang được tải xuống!',
        sendRequestFailed: 'Bạn đã gửi yêu cầu thất bại, vui lòng thử lại.',
      }
    },
    knowledgeBase: {
      knowledgeForPub: 'Kiến thức cơ bản dành cho Publisher',
      subKnowledgeForPub: 'Chuyên mục HyperLead dùng để giải đáp thắc mắc của bạn!',
      searchPost: 'Bạng đang thắc mắc về điều gì?',
      relatedPosts: 'Bài viết liên quan',
      noRelatedPost: 'Không có bài biết nào liên quan',
      updatedAt: 'Cập nhật lần cuối vào',
    },
    staticPage: {
      err404: '404 - Không tìm thấy trang!',
      err404Message:
        '<p>Có vẻ như chúng thôi không tìm thấy tài nguyên mà bạn tìm kiếm.</p><p>Trang bạn truy cập không tồn tại, không có sẵn hoặc không được tải đúng cách.</p>',
      btnBackToHome: 'Quay lại trang chủ',
      thankyou: 'Đăng ký thành công',
      thankyouMessage: '\n                <p>Chúc mừng! Bạn đã đăng ký thành công tài khoản tại HyperLead.</p>',
      completeTitle: "Hoàn tất!",
      completeDesc: "Mật khẩu của bạn đã được cập nhật.",
      loginNow: "Đăng nhập ngay",
    },
    termsAndConditions: {
      title: 'Điều khoản và chính sách',
      backToRegister: 'Về trang đăng ký',
    },
    privacyPolicy: {
      title: 'Chính sách bảo mật',
      backToRegister: 'Về trang đăng ký',
    },
    verifyEmail: {
      pleaseVerifyEmail: 'Vui lòng',
      verifyEmail: 'xác thực email',
      toUseAllFeatures: 'để sử dụng tất cả các tính năng',
    },
  },
  en: {
    components: {
      jDataTable: {
        showing: 'Showing',
        to: 'to',
        of: 'of',
        perPageText: 'Items per page',
        entries: 'entries',
        goToText: 'Go to page',
      },
      daterangepicker: {
        tooltipDefault: 'The date range can not exceed 90 days.',
      },
      latestOrders: {
        title: 'Detailed Conversion',
        order: 'Conversion',
        commission: 'Commission',
        status: 'Status',
        date: 'Time',
        approved: 'Success',
        rejected: 'Cancelled',
        pending: 'Pending',
        emptyTable: {
          topContent: 'No information',
          bottomContent: 'The latest order will be displayed here as soon as it is received'
        }
      },
      vsInputCopy: {
        copy: 'Copy',
      },
      flexibleSelect: {
        all: 'All',
        selected: 'selected',
        notFound: "Not found"
      },
      reportService: {
        all: 'All',
        conversionPending: 'Pending',
        conversionSuccess: 'Success',
        conversionCancel: 'Cancelled',
        invoiceNoProcess: 'On Hold',
        invoiceSuccess: 'Paid',
        invoiceProcessing: 'Processing',
      },
      carerH: {
        accountManager: 'Account Manager',
        supportText: 'If you need any support, kindly contact your AM',
        workingTime: 'Monday - Friday | 09:00AM - 06:00PM',
        contact: 'Chat with us',
        zalo: 'Contact via Zalo OA',
        fb: 'Contact via Fanpage',
        contactHelp: 'Contact help',
        urgentNote: 'If you need urgent support/after hours,'
      },
      modalRating: {
        error: 'Please select <b>Satisfaction Level</b>, <b>feedbacks</b> and <b>leave</b> your comment',
        title: 'Please Rate HyperLead!',
        subtitle: 'Select your satisfaction level',
        feedbackTitle: 'Leave your feedback about: (multiple choices)',
        ui: 'User Interface',
        ux: 'User Experience',
        feature: 'Features',
        support: 'Support',
        submit: 'Submit',
        thankTitle: 'Thanks for your contribution',
        thankSubtitle: 'We are trying our best to improve HyperLead everyday. <br/> (Closing after 3s)',
      },
      browseAdvertisementDialog: {
        title: "How to run Affiliate",
        topDescription: "Please provide HyperLead with information on how to run your Affiliate!",
        choose: "Select here",
        addOtherType: "Add Another Way to Run",
        create: "Create new",
        delete: "Delete",
      },
      filterAffSub: {
        addFilterAffSub: "More",
        remove: "Hide",
      },
      policyModal: {
        header: "Personal data protection policy",
        body: "In order to exchange information and use HyperLead's services, users need to confirm that they have read and understood <a class='policy-modal__link' href='/privacy-policy' target='_blank'>Privacy Policy</a>; and agree to consent to HyperLead's use, processing and transfer of your Personal Information as below.",
        save: "HyperLead allowed to store and process my basic personal data",
        purpose: "I have been clearly informed of the purpose of use of personal data from HyperLead",
        permission: "I have full discretion with my personal data",
        submit: "APPROVE"
      }
    },
    global: {
      justNow: 'just now',
      justNowTime: 'few seconds ago',
      ago: 'ago',
      second: 'second',
      minute: 'minute',
      hour: 'hour',
      day: 'date',
      week: 'week',
      month: 'month',
      year: 'year',
      seeMore: 'See more',
      dateRange: 'Date range',
      success: 'Success',
      pending: 'Pending',
      rejected: 'Cancelled',
      search: 'Search',
      all: 'All',
      cancel: 'Cancelled',
      info: 'Notifications',
      error: 'Error',
      warning: 'Warning',
      copySuccess: 'Copied',
      copyError: 'Copy error',
      total: 'Total',
      errorOccured: 'An error has occured',
      updateSuccess: 'Successfully updated',
      serverError: 'Not connected to server',
      noMatching: 'No matching data',
      noMatch: 'No data',
      keywordForSearch: 'What are you looking for?',
      apply: "Apply"
    },
    router: {
      home: 'Home',
      userProfile: 'User Profile',
      userProfilePayment: 'Payment Information',
      offer: 'Offer',
      offerInfo: 'Offer',
      news: 'News & Events',
      newsDetail: 'Blog',
      tools: 'Tools',
      createdLink: 'Created Links',
      parkingDomain: 'Parking Domain',
      masofferAPI: "HyperLead's API",
      postback: 'Postback',
      addPostback: 'Add Postback',
      editPostback: 'Edit Postback',
      report: 'Report',
      orderReport: 'Overview Report',
      orderReportDetail: 'Order Report',
      performanceReport: 'Performance Report',
      revenueReport: 'Revenue Report',
      pay: 'Payment',
      paymentHistory: 'Payment History',
      invoiceDetail: 'Details',
      loyalty: 'Loyalty',
      support: 'Support',
      termsAndConditions: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      aboutMasOffer: 'About HyperLead',
      faq: 'FAQs',
      paymentFAQ: 'Payment & Commission',
      linkFAQ: 'Tracking Link',
      accountFAQ: 'Account',
      offerFAQ: 'Offer',
      ticketManage: 'Ticket',
      ticketCreate: 'Ticket',
      ticketDetail: 'Ticket',
      knowledgeBase: 'Basic knowledge',
      knowledgeCategory: 'Basic knowledge',
      knowledgePost: 'Basic knowledge',
      login: 'Login',
      register: 'Register',
      findConversion: 'Find my conversions',
      hyperleadWrapped: 'Tổng kết năm'
    },
    verifyOtp: {
      submit: 'Submit',
      loading: 'Sending',
    },
    login: {
      warning: 'Warning',
      validateFormRegister: 'Please complete registration form',
      title: 'Log in',
      welcomeMessage: 'Welcome back, please log in!',
      username: 'Username / Email',
      password: 'Password',
      rememberMe: 'Remember',
      forgetPassword: 'Forgot password?',
      register: 'Sign up',
      login: 'Log in',
      or: 'Or',
      and: ' and ',
      loginWithGoogle: 'Log in with Google',
      loginWithDemo: 'Log in with Demo',
      registerSuccessTitle: 'Successful register!',
      registerSuccessText: 'Please check your email, including the Spam inbox, for an activation link!',
      areYouNotHaveAnAccount: "Don't have an account yet? ",
      areYouHaveAnAccount: 'Already have one?',
      loginNow: 'Log in',
      letCreateAccount: 'Create a new account',
      acceptTermsQuote: 'By registering for an account, you agree to our',
      termsAndConditions: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      ourAbout: ' ',
      requireVerifyEmailDesc:
        "<b>7 days</b> as from you registered our service. <br/>\n            Please <b>verify your email</b> to use Hyperlead's service. <br/><br/>\n            If you haven't found a verification email from us, please check your Spam",
      requireVerifyEmailButton: 'Request  email verification.',
    },
    register: {
      title: 'Register',
      intro: 'Complete the following information to create a new account.',
      fullName: 'Full name',
      firstName: 'First name',
      lastName: 'Last name',
      userName: 'Username',
      phoneNumber: 'Phone number',
      campaign: 'Campaign',
      password: 'Password',
      confirmPassword: 'Confirm password',
      termsConditionsAgree: 'I agree to the terms & conditions',
      enterpriseName: 'Company Name',
      representativeName: 'Representative Name',
      position: 'Position',
      question: 'Select your account type',
      personalTab: 'Personal',
      enterpriseTab: 'Company',
      descriptionTextPassword:
        'Password must be at least 8 characters and contains at least 1 uppercase letter, 1 lowercase letter, 1 number and may contain special characters.',
        authInfo: {
          title: 'Authentication information',
          intro: 'Verification code will be sent to phone number',
          changePhone: 'Change Phone number',
          zaloReceive: 'Receive OTP via Zalo',
          smsReceive: 'Receive OTP via SMS',
          btnNext: 'Next'

        },
      },

    forgetPassword: {
      title: 'Recover your password',
      intro: 'Enter your information to receive instructions to reset your password',
      recoverPassword: 'Send instructions',
      checkEmail: 'An intruction has been sent to your mailbox',
      emailNotExists: 'Email does not exist, please recheck or',
      registerNow: 'Register now',
    },
    authVerify: {
      activatingAccount: 'Activating account',
      successfulTitle: 'Verified',
      successfulDescription: 'Redirecting to login page after 3s.',
      errorTitle: 'Failed',
      errorDescription: 'Please check your OTP. <br /> Redirecting to login page after 5s.',
    },
    resetPassword: {
      title: 'Create new password',
      intro: 'Please enter your new password',
      reset: 'Reset',
      password: 'Password',
      confirmPassword: 'Confirm password',
    },
    authError: {
      1000: 'please agree to terms & conditions',
      1001: 'Existed user! Please try again.',
      1002: 'Submitted.',
      1003: 'Email does not exist',
      1004: 'Success! Please go back to login page',
      1005: 'Account does not exist',
      1006: 'Incorrect login info or account not verified',
      1007: 'Account is blocked!',
      1008: 'Incorrect password',
      1009: 'Email existed',
      password: 'New password is required',
      confirmPassword: 'Confirm password is required',
    },
    topbar: {
      theme: 'Theme',
      dark: 'Dark',
      light: 'Light',
      account: 'Account',
      logout: 'Log out',
      notification: 'Notification',
      newNotification: 'New notification',
      markAllAsRead: 'Mark as read',
      am: 'AM',
      noRank: "No ranking",
      categoryNotification: {
        all: 'All',
        preferential: 'Promotions',
        commission: 'Commission',
        campaign: 'Offers',
        other: 'Other'
      }
    },
    footer: {},
    daterangepicker: {
      today: 'Today',
      yesterday: 'Yesterday',
      last7days: 'Last 7 days',
      last30days: 'Last 30 days',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisQuarter: 'This quarter',
      lastQuarter: 'Last quarter',
    },
    sidebar: {
      new: 'New',
      dashboard: 'Home',
      hyperleadWrapped: 'Tổng kết năm',
      hyperleadWrappedResult: 'Kết quả của bạn',
      offer: 'Offer',
      news: 'News & Events',
      pay: 'Payment',
      commissionsRevenue: 'Revenue',
      paymentHistory: 'Payment History',
      memberOffer: 'Loyalty',
      tool: 'Tools',
      createdLinks: 'Created Links',
      report: 'Report',
      orderReport: 'Campaign Report',
      orderReportDetail: 'Conversion Report',
      performanceReport: 'Performance Report',
      revenueReport: 'Revenue Report',
      support: 'Support',
      termsConditions: 'Terms & Conditions',
      aboutMasOffer: 'About HyperLead',
      faq: 'FAQs',
      payment: 'Payment & Commission',
      trackingLink: 'Tracking Link',
      account: 'Account',
      campaign: 'Offer',
      ticketManage: 'Ticket',
      ticketCreate: 'Create ticket',
      knowledgeBase: 'Basic knowledge',
      findConversion: 'Look up conversion',
      hot: 'HOT'
    },
    affsub: {
      affsub1: 'Aff_sub1',
      affsub1Placeholder: 'E.g: google, facebook, tiktok,...',
      affsub2: 'Aff_sub2',
      affsub2Placeholder: 'E.g: cpc, ads, banner,...',
      affsub3: 'Aff_sub3',
      affsub3Placeholder: 'E.g: the-tin-dung, vay-sinh-vien,...',
      affsub4: 'Aff_sub4',
      affsub4Placeholder: 'E.g: ngay-10-10, giam-lai-suat,...',
    },
    home: {
      autoUpdate: 'Auto update',
      noUpdate: 'No update',
      autoUpdateOn: 'Auto update on',
      autoUpdateOff: 'Auto update off',
      successConversionsTotal: 'Successful conversions',
      conversionsTotal: 'Conversions',
      successCommission: 'Successful commission',
      pendingCommission: 'Pending commission',
      rejectedConversion: 'Cancelled commission',
      news: 'News',
      moNews: 'HyperLead News',
      moPromotions: 'Promotions',
      latestOrders: 'Latest Conversion',
      updateNotice: 'UPDATE ID CARD & PAYMENT INFORMATION!',
      dearPub: 'Dear Publisher,',
      pleaseUpdate: 'To ensure on time payment, please update',
      IDCardInfo: 'ID card information,',
      paymentInfo: 'Payment information',
      contactAM: 'and contact your Account Manager to verify the information.',
      bestRegards: 'Best Regards!',
      clicks: 'Click',
      viewReport: 'View report',
      todayRevenue: 'Today revenue',
      overviewText: 'Overview',
      revenueWeekText: 'Weekly revenue',
      revenueMonthText: 'Monthly revenue',
      welcome: 'Welcome',
      welcomeQuotes: 'Check out the stats below to increase efficiency!',
      cvrTooltip: 'Conversion rate = (Total successful conversions/Clicks) x 100.',
      epcTooltip: 'Earnings per Click = Success Revenue/Clicks',
      dateRangeToolTip: 'The selection period must be within 90 days from the start date.',
      weekRevenueTooltip: 'Monday to Sunday of the current week',
      monthRevenueTooltip: '1st to the last day (30th or 31st) of the current month',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun',
      chartConversion: 'Conversion',
      chartRevenue: 'Revenue',
      newDashboard: {
        switchLabel: 'New interface',
        popup: {
          title: 'Try new interface',
          content: 'Activate this switch to try better New Interface now!',
          button: 'Understood',
        }
      },
      userOnboarding: {
        banner: {
          title: 'Wondering how to use our features?',
          btnExit: 'I want to discover myself',
          btnContinue: 'Guide me'
        },
        step1: {
          title: 'When you need support',
          content: 'Click here to view your support agent information.',
        },
        step2: {
          title: 'Register an offer',
          content: 'Access "Offer" tab to register, create a link, and start earning',
        },
        step3: {
          title: 'View hottest news',
          content: 'Access "News & Events" to view newest updates about commission, bonus, and event',
        },
        step4: {
          title: 'Reports & Conversions',
          content: 'Access "Overview Report" to check your performance. <br>Access "Overview Report" for conversion detailed information.',
        },
        step5: {
          title: 'Loyalty & Redeem',
          content: 'Redeem great gifts & coupon here',
        },
        step6: {
          title: 'Questions & Support',
          content: "Access here for beginner's articles and send support request",
        },
        stepMessenger: {
          title: 'When you need to chat right away',
          content: "Click here to contact a HyperLead specialist",
        },
        stepToggle: {
          title: 'Click here to see our amazing features'
        },
        btnStep: {
          btnExit: 'Close',
          btnContinue: 'Next',
          btnFinish: 'Complete!',
        },
        rating: {
          title: 'Is this useful?',
          btnYes: 'Yes, of course',
          btnNo: 'Not at all'
        }
      }
    },
    ekyc: {
      title: 'Update Identity Information',
      remind: 'Your account has not updated identification information. Please update to ensure full benefits from HyperLead',
      gotoUpdate: 'Go to update',
      instruction: 'Choose a good quality photo with clear text. Then click Continue',
      contact: 'If you need support to perform EKYC, please contact HyperLead via',
      continue: 'Next'
    },
    offer: {
      unknown: 'Unknown',
      linkAffiliate: 'Affiliate link',
      shortLink: 'Shorten link',
      keyword: 'Keyword',
      keywordPlaceholder: 'Search for campaigns...',
      category: 'Category',
      specialOffers: 'Campaign status',
      makeLink: 'Create link',
      register: 'Register',
      pending: 'Pending',
      paused: 'Paused',
      locked: 'Locked',
      commission: 'Commissiom',
      conversionTime: 'Conversion time',
      requestTitle: 'Offer Registration',
      confirm: 'Register',
      approvalRate: 'Approve',
      sendRequest: 'Send request',
      sendRequestFailed: 'Your request has failed, please try again.',
      recentlyCreatedLink: 'Recently created links',
      updateTime: 'Created date',
      btnSeeAllLinks: 'See all link',
      sectionHot: 'HOT Offers',
      sectionPopular: 'Popular Offers',
      sectionAnother: 'Other Offers',
      running: 'Approved',
      unregister: 'Not registered',
      advertisementRequired: 'Please choose source type',
      here: 'here',
      popupTitle: 'What traffic type(s) will you use to push this offer?',
      popupDesc: "If you want to provide more info about you traffic please",
      popupNote:
        'Note: Please contact us via chat widget if the Registration status is still Pending after 24 hours.',
      popupDropdownAdvertise: 'Select here',
      updatedAt: 'Updated at',
      addNewTrafficType: "Add new traffic type",
      registrationSuccessfully: "Registration successfully",
      gotIt: "I got it!",
      userOnboarding: {
        banner: {
          title: 'Did you know how to <b>create a link</b>?',
          btnExit: 'I knew it',
          btnContinue: 'Not yet, guide me'
        },
        campaign: {
          step1: {
            title: 'Step 1',
            content: `
                        This is guide for you to create a link.
                        First, access ”Offer” tab, search for an offer, and click ”Create link”
                    `
          },
          step2: {
            title: 'Step 2',
            content: `
                        Check following info: Domain, Landing Page. And click "Create link”
                    `
          },
          step3: {
            title: 'Step 3',
            content: `
                        Read “Terms & Conditions” carefully. Then click ”Agree”
                    `
          },
          step4: {
            title: 'Complete!',
            content: `
                        This is your created link. Click at icon copy <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <rect x="0.541992" width="22.9156" height="21.7978" rx="6" fill="url(#pattern0)"/>
                            <defs>
                            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_1762_516368" transform="scale(0.0243902 0.025641)"/>
                            </pattern>
                            <image id="image0_1762_516368" width="41" height="39" xlink:href="data:image/png;base64,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"/>
                            </defs>
                            </svg> to copy the link and start earning now!
                    `
          },
        }
      }
    },
    offerInfo: {
      info: 'Campaign Info',
      name: 'Campaign Name',
      homepage: 'Homepage',
      offerType: 'Offer Type',
      address: 'Address',
      commissionRate: 'Commission Share',
      successRate: 'Successful Rate',
      conversionTime: 'Average Conversion Time',
      commissionRule: 'Commission Rules',
      specialNote: 'Important Note',
      cookieRule: 'Cookies Rules',
      description: 'Description',
      makeLink: 'Create link',
      createdLinks: 'Created Links',
      orderReport: 'Conversion Report',
      registrationProcess: 'Registration Process',
      promotionalMaterial: 'Advertising Material',
      tips: 'Tips of this campaign',
    },
    offerGenLink: {
      title: 'Create Tracking Link',
      titleLink: 'Tracking Link',
      encodedLink: 'Encrypted Link',
      chooseSSL: 'Select SSL Domain',
      chooseDomain: 'Domain',
      landingPage: 'Landing Page',
      advanced: 'Advanced',
      customLink: 'Custom Link',
      customLinkError: 'Custom link allows formatting as unsigned letters, numbers and some special characters (_ - . ~)',
      makeLink: 'Create Link',
      termsConditions: 'Terms & Conditions',
      termsConditionsAgree: 'Agree',
      chooseDomainTooltip: 'Selecting options under "Facebook Traffic" will prevent link blocking if you are promoting via Facebook',
      landingPageTooltip: 'Select the approriate Landing Page for your promotion. For example, if you are advertising to iOS users, select Landing Page for iOS.',
      titleLinkTooltip: 'Distribution link is a URL created to track user activity after they click the link and ensure marketing commissions are recorded for the publisher.',
      customLinkTooltip: 'A shortened link is a URL that has been shortened from the distribution link, making it more concise and visually appealing.'
    },
    news: {
      keyword: 'Keyword',
      keywordPlaceholder: 'E.g: atmonline, cash24,...',
      selectOffer: 'Select offer',
      selectNewType: 'News Type',
      all: 'All',
      offerNew: 'Offer News',
      notice: 'Notification',
      promotion: 'Promotion',
      event: 'Event',
      search: 'Search',
      noNew: 'No news yet',
      special: 'Special',
      announcement: 'Notification',
      specialNews: 'Special News',
      anotherNews: 'Other News',
    },
    createdLink: {
      date: 'Created at',
      dateTitle: 'Created at',
      offer: 'Offer',
      chooseOffer: 'Select offer',
      advanced: 'Advanced',
      link: 'Tracking Link',
      toggleColumn: 'Show/Hide column',
      shortenLink: 'Shorten Link',
      conversion: 'Conversion',
    },
    parkingDomain: {
      title: 'Guideline of Adding Domain',
      instruction: 'I. GUIDELINE',
      step1: '\n                <p class="font-semibold">Want to create a link with your own domain?</p> <br/>\n                <p class="font-semibold">Step 1: Configure Parking Domain </p>\n                <p>Add CNAME record at your DNS provider to domain: link.riofintech.net. </p><br/>\n\n                <p>Example: Point your domain  go.yourdomain.com to link.riofintech.net</p>',
      step2: '\n                <p class="font-semibold">Step 2: Add your domain to HyperLead</p>\n                <span>Enter your domain to connect with HyperLead</span>',
      step3: '\n                <p class="font-semibold">Step 3: Select your own domain and generate tracking links</p>\n                <p>Make sure to check if your domain is redirecting correctly!</p>',
      here: 'here',
      addDomain: 'II. ADDING DOMAIN',
      addDomainLabel: 'The domain',
      addDomainPlaceholder: 'Example: go.yourdomain.com',
      addAndCheck: 'Adding domain',
      addedList: 'Your domain list',
      add: 'Add',
      domainRequired: 'Please enter your domain',
      addDNS: 'Add DNS CNAME Record to your domain:',
      error: {
        1020: 'Please enter your domain!',
        1021: 'Incorrect domain. Please try again!',
        1022: 'Domain is already used by another publisher. Please try again!',
        1023: 'You have already added this domain',
        1024: 'An error has occurred',
      },
      notFound: 'No domain added.',
    },
    masofferAPI: {
      title: 'Use the following link to get information about all offers',
      param: 'Parameter',
      isRequired: 'Required?',
      required: 'Required',
      notRequired: 'Not required',
      description: 'Description',
      value: 'Value',
      response: 'Response:',
      success: 'Successful',
      failed: 'Failed',
      offers: 'Offer',
      conversionTitle: 'Conversion',
      linkGenerator: {
        copy: 'Copy',
        offer: {
          pubId: 'Username',
          token: 'Token',
        },
        conversion: {
          publisherId: 'Username',
          token: 'Token',
          offerId: 'Offer ID',
          keyword: 'Keyword',
          dateFrom: 'Start date of conversion list. (Default: 10 days ago).',
          dateTo: 'The end date of the list conversions.(Default: 10 days from now).',
          page: 'Page',
          limit: 'Record limit',
          statusCode: 'Conversion status',
          rejected: 'Cancelled',
          pending: 'Pending',
          success: 'Success',
          transactionId: 'Conversion ID',
        },
      },
      offer: {
        title: 'Use the following link to get information about all offers:',
      },
      conversion: {
        title: 'Use the following link to get information about all conversions:',
      },
    },
    postback: {
      addPostback: 'Add Postback',
      stt: 'NO.',
      offer: 'Offer',
      status: 'Status',
      createdAt: 'Created at',
      all: 'All',
      active: 'Active',
      deactive: 'Deactive',
      edit: 'Edit',
      remove: 'Remove',
      choosingOffer: 'Select offer',
      choosingActive: 'Select status',
      enterYourPostbackFind: 'Enter a postback you want to find',
    },
    addPostback: {
      offer: 'Offer',
      togglePostback: 'Active/Deactive Postback',
      active: 'Active',
      deactive: 'Deactive',
      advanced: 'Advanced',
      successTransaction: 'Successful conversion',
      pendingTransaction: 'Pending conversion',
      rejectedTransaction: 'Cancelled conversion',
      errorOccured: 'An error has occurred',
      noOfferError: 'No offer selected!',
      headerInvalidJson: 'Incorrect JSON format of Request Header, please check again!',
      invalidSuccessLink: 'Incorrect format of Postback for successful conversion, please check again!',
      invalidPendingLink: 'Incorrect format of Postback for pending conversion, please check again!',
      invalidRejectedLink: 'Incorrect format of Postback for cancelled conversion, please check again!',
      noLink: 'Empty Posback, please add at least 1 link!',
      addSuccess: 'Successful',
      addFailed: 'Failed',
      back: 'Back',
      save: 'Save',
      placeholder: 'Your postback link',
      user_manual: 'Guideline',
    },
    orderReport: {
      daterange: 'Date range',
      filterByAccount: 'Select account type',
      subUser: 'Sub-user',
      orderStatus: 'Conversion status',
      paymentStatus: 'Payment status',
      campaignId: 'Offer ID',
      exportExcel: 'Export file',
      currentAccount: 'Current account',
      chooseAccount: 'Select account',
      errorOccured: 'An error has occurred',
      requestFailed: 'Request failed!',
      requestSuccess: 'Request successful! Downloading!',
      requestSuccessDescription: 'Note: You can only download files every 1 minute',
      downloadTimeoutWarning: 'You can only download files every 1 minute. Maximum period of 90 days',
      noData: 'No data! Please choose again',
      downloading: 'Downloading...',
      customReport: 'Custom Report',
      customAdvance: 'Display settings',
      reportTuningFilter: 'Add the corresponding column to the report',
      reportTuningFilterTitle: 'Adjust Report',
      tutorialChooseOrder: 'Click on each line to see conversion details ',
      all: 'All',
      conversionsTitle: 'Conversion',
      estimateRevenue: 'ESTIMATED REVENUE',
      revenue: 'Revenue',
      saleAmount: 'Sale amount',
      chooseStatus: 'Select status',
      chooseOffer: 'Select offer',
      resetFilter: "Filter reset",
      otherLabel: "Others",
      infoDisplayedBy: "Information displayed by",
      cancelRevenue: "Cancellation revenue",
      filterByAffSub: "Filter by Aff_sub",

      order: "ORDER",
      totalClick: "TOTAL CLICK",
      total: "Total",
      approved: "Approved",
      rejected: "Rejected",
      pending: "Pending",
      cvrTooltip: "Conversion rate = (Total conversions/Clicks) x 100.",
      epcTooltip: "Earnings per Click = Success Revenue/Clicks",
      estimateRevenueTooltip: "Estimate revenue tooltip",
      totalOrder: "Total order",
      totalSuccessfulOrder: "Total successful order",
      totalPendingOrder: "Total pending order",
      totalCancelOrder: "Total cancel order",
      revenueFilter: "Revenue filter",
      totalRevenue: "Total revenue",
      totalSuccessfulRevenue: "Total successful revenue",
      totalPendingRevenue: "Total pending revenue",
      totalCancelRevenue: "Total cancel revenue",
      invoiceNoProcess: "Invoice no process",
      invoiceSuccess: "Invoice success",
      invoiceProcessing: "Invoice processing",
      otherInfo: "Other info"
    },
    orderReportDetail: {
      resetFilter: "Filter reset",
      tutorialChooseOrder: 'Click on each line to see conversion details ',
      daterange: 'Date range',
      status: 'Status',
      otherInfo: 'Other information',
      findByTransactionID: 'Search by Transaction ID',
      findByConversionID: 'Search by Conversion ID',
      findByClickID: 'Search by Click ID',
      findByAccount: 'Search by account type',
      currentAccount: 'Current account',
      chooseAccount: 'Select account',
      subuser: 'Sub-user',
      offer: 'Offer',
      device: 'Device',
      productName: 'Product name',
      referer: 'Referer',
      clickURL: 'Click URL',
      errorOccured: 'An error has occurred',
      totalLabel: 'Total $total',
      reportTuningFilterTitle: 'Report Filter',
      conversionId: 'Conversion ID',
      campaignId: 'Offer ID',
      clickTime: 'Click time',
      generateTime: 'Conversion time',
      paymentStatus: 'Payment status',
      conversionStatus: 'Conversion status',
      conversionPubPayout: 'Estimated revenue',
      statusMessage: 'Note',
      productCategory: 'Product Category',
      saleAmount: 'Sale amount',
      other: 'Others',
      chooseStatus: 'Select status',
      chooseOffer: 'Select offer',
      exportExcel: 'Export file',
      statusUpdatedTime: "Status updated time"
    },
    performanceReport: {
      filter: 'Filter',
      daterange: 'Date range',
      offer: 'Offer ID',
      chooseOffer: 'Select offer',
      advanced: 'Advanced',
      viewOptions: 'View options',
      dailyChart: 'Daily chart',
      hourlyChart: 'Hourly chart ',
      dailyAndHourChartGroup: 'Chart data is displayed as',
      conversion: 'Conversion',
      commission: 'Commission',
      daily: 'Daily',
      hourly: 'Hourly',
      devicesAndBrowsers: 'Browsers and  devices',
      byConversions: 'Conversion',
      byCommissions: 'Commission',
      byDevices: 'Devices',
      byBrowsers: 'Browser',
      ratio: 'Ratio',
      detailsTable: 'Details',
      detailsTableGroup: 'Table data is displayed as',
      toggleColumns: 'Show/Hide column',
      pendingConversion: 'Pending converion',
      successConversion: 'Successful conversion',
      rejectedConversion: 'Cancelled conversion',
      pendingCommission: 'Pending commission',
      successCommission: 'Successful  commission',
      rejectedCommission: 'Cancelled commission',
      total: 'Total',
      tooltipChartDay: 'Data is collected  daily',
      tooltipChartHour: 'Data is collected  hourly',
      exactly: 'Exactly',
      contain: 'Relativity',
      reportTuningFilterTitle: 'Report filter',
    },
    revenueReport: {
      fromYear: 'From year',
      toYear: 'To year',
      month: 'Month',
      successCommission: 'Successful commission (VND)',
      pendingCommission: 'Pending commission (VND)',
      rejectedCommission: 'Cancelled  commission (VND)',
      paid: 'Paid (VND)',
      remain: 'Remaining (VND)',
      total: 'Total',
      monthDetails: 'Monthly revenue details',
      generalDetails: 'Revenue details',
      errorOccured: 'An error has occurred',
    },
    paymentHistory: {
      all: 'All',
      status: 'Status',
      pending: 'Pending',
      completed: 'Completed',
      createdAt: 'Issued day',
      amount: 'Amount',
      paymentPeriod: 'Payment Period',
      note: 'Note',
      details: 'Details',
      noInvoice: 'No invoice',
      paymentCategory: 'Payment category',
      invoiceCreatedDayTooltip: 'Created date',
      invoiceTimeTooltip: 'Invoice date range',
      recurringPayments: 'Recurring payment',
      advancePayment: 'Advance payment',
      noteUpdateTime:
        ' Payment reconciliation will be done on the last day of month T+1. <br/> \n            Status will be updated on this page. More information about payment can be found at   \n            <span class="font-bold">FAQ item</span>',
    },
    invoiceDetails: {
      invoice: 'Invoice',
      invoiceID: 'Invoice ID',
      invoiceDate: 'Invoice date',
      receiptment: 'Recipient',
      vimarket: 'RIO Viet Nam Technology JSC.,',
      hanoi: 'HaNoi Headquarters',
      hanoiAddress: '2nd Floor, Ecolife Capitol Tower, 58 To Huu, Nam Tu Liem District, Hanoi',
      hcm: 'Ho Chi Minh Office',
      hcmAddress: '3i Thích Quảng Đức, Ward 3, Phú Nhuận District, Ho Chi Minh City',
      transactions: 'Transactions',
      products: 'Products',
      commission: 'Commissions',
      total: 'Total',
      paymentMonth: ' Monthly payment',
      note: 'Note',
      campaign: 'Offer',
      bank: 'Domestic bank account',
      paypal: 'Paypal account',
      paymentInfo: 'Payment information',
      paymentType: 'Payment method',
      paymentBankName: 'Bank name',
      paymentBranch: 'Branch',
      paymentAccountHolder: 'Account holder',
      paymentAccountNumber: 'Account number ',
      paymentAccountCard: 'Card number',
      tax: 'Tax code'
    },
    loyalty: {
      missionStatus: 'Mission status',
      currentSessionName: 'Current season',
      tag: 'New',
      mop: 'HPoint',
      rp: 'Ranking Point',
      unauthorized: 'Oh, no! :( <br/> Loyalty is paused',
      contactAM: 'We will be back soon.',
      register: 'Register',
      congrats: 'Congrats!',
      congratsMsg: 'You are a Loyalty Publisher and can redeem points for amazing rewards!',
      info: 'Info',
      mission: 'Mission',
      reward: 'Reward',
      pointHistory: 'Point History',
      about: 'About & Conditions',
      currentRank: 'Current Rank',
      newRankMsg: 'Congrats, you have achieved ',
      chart: 'Ranking Chart',
      rank: 'Rank',
      account: 'Account',
      status: 'Status',
      all: 'All',
      inProgress: 'In progress',
      accomplished: 'Completed',
      accomplished2: 'Completed, waiting for rewards',
      completed: 'Rewarded',
      receiveReward: 'Reward',
      noMission: 'No mission',
      bonus: 'Bonus',
      time: 'Time',
      startTime: 'Start time',
      endTime: 'End time',
      receiveSuccessTitle: 'Reward successfully received',
      receiveSuccessText: 'Reward points added',
      receiveFailedTitle: 'Failed to receive reward',
      receiveFailedText: 'Please try again or contact AM for support',
      noReward: 'No reward available',
      getNow: 'Redeem now',
      pending: 'Pending',
      redeemHistory: 'Redeem History',
      rewardName: 'Name',
      noRedeem: 'You have not redeemed any reward yet',
      viewAllHistory: 'View all history',
      redeem: 'Redeem',
      redeemInfo: 'Redeem Info',
      required: '*required',
      addressPlaceholder: 'Address',
      districtPlaceholder: 'District',
      cityPlaceholder: 'Province/City',
      note: 'Note',
      quantity: 'Quantity',
      notEnoughPoint: 'Not enough point to redeem',
      redeemConfirm: 'Confirm',
      requestDate: 'Request Date',
      approveDate: 'Approval Date',
      redeemSuccessTitle: 'Redeem Success!',
      redeemSuccessText: 'AM has received your request',
      redeemFailedTitle: 'Redeem Failed!',
      redeemFailedText: 'Please try again or contact AM for support',
      filterBySeason: 'Filter by Season',
      index: 'No.',
      type: 'Type',
      amount: 'Point',
      detail: 'Detail',
      issueDate: 'Issued date',
      missionComplete: 'Mission completed',
      addPoint: 'Plus point',
      minusPoint: 'Minus point',
      rewardPending: 'Pending reward',
      rewardApproved: 'Approved reward',
      rewardRejected: 'Rejected reward',
      noPointHistory: 'No poin historry',
      loyaltyIntro:
        '<p class="normal-title">Introduction about</p><p><span class="normal-title">HyperLead Loyalty </span><span class="blue-title">Program</span></p>',
      iHaveRead: 'I accept the',
      loyaltyTerms: "HyperLead Membership Program's terms and conditions",
      is_handling: 'Processing',
    },
    accountInfo: {
      save: 'Save',
      sendRequest: 'Request to change information',
      refresh: 'Reset',
      updateSuccess: 'Update Successful',
      updateFailed: 'Update Failed',
      requestSuccess: 'Request Successful',
      requestFailed: 'Request Failed',
      boxContentRequest: 'Please contact your AM or send a Ticket to verify your request!',
      btnUpdate: 'Update',
      btnSubmitInfo: 'Submit infomation',
      alertPassedInfo: 'Payment info confirmed',
      alertWaitAMConfirm: 'Wait for AM approval',
      alertYouAre: 'You have a',
      alertRequest: 'request',
      alertNotConfirmByManager: 'to change information not approved!',
      alertAdvertisement: "Please fill in your exact information <span class='font-bold'>Traffic type</span>to be approved quickly",
      general: {
        title: 'General information',
        username: 'Username',
        firstName: 'Last name',
        lastName: 'First name',
        enterpriseName: 'Company name',
        representativeName: 'Representative name',
        position: 'Position',
        website: 'Website',
        phoneNumber: 'Phone number',
        phoneError: 'Incorrect format',
        phoneEmpty: 'Required',
        nameEmpty: 'Required',
        emailVerified: 'Email verified',
        emailNotVerify: 'Email not verified',
        verify: 'Vefiry',
        verified: 'Verified',
        verifying: 'Verifying',
        verificationSuccessful: 'Verification email sent',
        checkMailbox: 'Please check your mailbox to verify your account',
      },
      changeEmail: {
        title: 'Password',
        email: {
          new: "Enter new email",
          old: "Old email",
        },
        password: 'Enter new password',
        wrongPassword: 'Incorrect password',
        save: 'Save',
        changeYourEmail: "Change your email",
        infoBelow: "To change email, please enter all information below:",
        emailChangeType: {
          placeholder: "Select the email change type",
          am: "Submit change request to AM",
          email: "Confirm via email"
        },
        responseAM: {
          line1: "Your email change request has been sent to AM. The time it takes for AM to confirm changes is 1-2 days.",
          line2: "During this time, AM may contact you to collect some additional necessary security information."
        },
        ok: "OK",
        responseSendEmail: {
          line1: "Your old email and new email have just received a confirmation request email. To change your email, please check and click 'Confirm' on both emails.",
          line2: "If you cannot find mail from HyperLead, please check your Junk or Spam folder.",
          note: "<b>Note</b>: The confirmation link is only valid for 10 minutes. <b>You need to repeat the step to change Email.</b>",
        },
        close: "Close",
        responseVerified: "Congratulations! You have successfully changed your Email.",
        responseExpired: "The time has expired to confirm via old and new emails. To redo the email change, please close this notification, and redo the email change within 10 minutes.",
        countDownText: "New email confirmation time remaining",
        successChangeEmail: {
          title: "Confirmed successfully",
          content_new: "You have successfully confirmed the change to email via new email. Please check your old email and confirm to complete the email change.",
          content_old: "You have successfully confirmed the change to email via current email. Please check your new email and confirm to complete the email change."
        },
        failedChangeEmail: {
          title: "Confirmation failed",
          content: "The confirmation link is incorrect or has expired. Please try to retrieve a new link."
        }
      },
      changePassword: {
        title: 'Password',
        oldPassword: 'Old password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        notExists: 'Account does not exist, please check again',
      },
      info: {
        created_at: 'Account creation date',
        trafficType: 'Traffic type',
        title: 'Overview',
        campaign: 'Offer',
        taxNumber: 'Tax Number',
        birthDate: 'Date of birth on ID',
        cmndNumber: 'ID number',
        cmndPlace: 'XXXX XXXX XXXX',
        cmndName: 'Name on ID',
        cmndNamePlace: 'Example: Nguyễn Văn A',
        chooseOtherPicture: 'Choose other image',
        cmndLocation: 'Place of issue',
        cmndLocationPlace: 'Place of issue',
        cmndAddress: 'Place of residence',
        cmndAddressPlace: 'Example: Bạch mai, Hai Bà Trưng, Hà Nội',

        cmndDate: 'Issued Date',
        cmndFront: 'Front',
        cmndBack: 'Back',
        imageIdentify: 'Photo taken on both sides of ID',
        permanentAddress: 'Permanent address',
        choosePicture: 'Choose image',
        wrongFormatTitle: 'Incorrect format',
        wrongFormatText: 'Please choose an image with a png, jpg or jpeg',
        bigImageTitle: 'Image too big!',
        bigImageText: 'Image size must be < 5MB',
        error: {
          IDNumber: 'ID number is required',
          IDName: 'Name is required',
          dateOfBirth: 'Date of birth is required',
          IDWhere: 'Please enter place of issue',
          dateOfID: 'Please enter issue date',
          imageF: 'Please upload the front of Id',
          imageB: 'Please upload the back of Id',
        },
      },
      advertisement: {
        title: 'Traffic Type',
        trafficType: 'Traffic source',
        childrenTrafficType: 'Traffic type',
        description: 'Description',
        url: 'URL',
        image: 'Image',
        action: 'Add',
        close: 'Close',
        maximumFilesSelectMessage: 'Total number of images selected is larger than allowed',
        maxFileSizeMessage: 'Selected file size __FILENAME__ is larger than allowed __SIZE__',
        advertisementEmptyMessage:
          "<p>You have not updated any traffic type, <br/> Please select <span class='text-primary font-semibold'>“New source type”</span> to update.</p>",
        form: {
          trafficType: 'Traffic Source',
          trafficTypePlaceholder: 'Select  traffic source',
          childrenTrafficType: 'Traffic type',
          childrenTrafficTypePlaceholder: 'Select traffic type',
          description: 'Description',
          descriptionPlaceholder: 'Enter traffic type',
          url: 'URL',
          urlPlaceholder: 'E.g: https://www.abc.com/xyz',
          image: 'Image',
          delete: 'Delete',
          action: 'Save',
          actionSaveImage: 'Select image',
          limitMessage: 'Maximum 2 images allowed',
          noOptionsChildrenTrafficType: "<p>Please select <span class='font-semibold'>Traffic source</span> first</p>",
        },
      },
      payment: {
        title: 'Payment account',
        topNotice:
          ' This is the payment information HyperLead will use. \n                If the information is incorrect, you will not be paid. <br/> \n                Note: You can choose only 1 payment method.',
        default: 'Select as default method (Save only one method)',
        bank: 'Domesic bank account (Recommended)',
        paypal: 'Paypal account',
        bankAccount: 'Bank account',
        bankName: 'Bank name',
        bankBranch: 'Branch (If any)',
        bankAccountHolder: 'Account holder',
        bankAccountNumber: 'Account number',
        bankAccountCard: 'Card number',
        postOffice: 'Post office',
        postOfficeName: 'Post Office Name',
        postOfficeReceiver: 'Receiver',
        defaultPaymentMethod: "Select default payment method",
        defaultPaymentAlert: "Please select a payment method",
        error: {
          bankName: 'Bank name is required',
          bankBranch: 'Branch is required',
          accountHolder: 'Account holder is required',
          accountNumber: 'Account number is required',
          postOffice: 'Post office is required',
          receiver: 'Receiver is required',
          IDNumber: 'ID number is required',
          dateOfID: 'Issue date is required',
          placeOfID: 'Issue place is required',
          email: 'Email is required',
        },
      },
      social: {
        title: 'Social network',
      },
      setting: {
        title: 'Setting',
        notification: 'Notification',
        invoiceUpdate: 'Invoice updates',
        newPromotionUpdate: 'New promotion updates',
        commissionUpdate: 'Commisions updates',
        theme: 'Theme',
        light: 'Light',
        dark: 'Dark',
      },
      history: {
        title: 'Request history',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Reject',
        requestedDate: 'Date',
        status: 'Status',
        changedInfo: 'Changed information',
        tax_code: 'Tax number',
        cmnd: 'ID number',
        email: 'Email',
        mobile: 'Phone number',
        payment: 'Payment',
        note: 'Note: For requests to change personal information and payment, please contact your AM or <a href="/support/ticket-create" data-route="ticket-create" class="router-link">send Ticket</a> to approve!',
      },
      apiToken: {
        publisherKey: 'Use with HyperLead WordPress plugins',
        apiToken: "Authenticate on request to HyperLead's API",
      },
    },
    support: {
      ticket: {
        enterYourTicketFind: 'Enter ticket you want to find',
        answer: 'Answer',
        attachFile: 'Attach File',
        attachment: '(Attachment)',
        attachmentTitle: 'Attachment',
        attachmentCondition: 'Limit upload {limitedSize}MB',
        attachChooseFile: 'Choose file',
        autoCloseInfo: ' The AM support is the last responder. This ticket will automatically close after {hours}.',
        availableFileType: 'Allow image, video, doc, xls, csv, zip, rar file type',
        btnClose: 'Close ticket',
        btnCreate: 'Create a new Ticket',
        btnReOpen: 'Reopen',
        btnReset: 'Reset',
        btnSend: 'Send',
        btnSendMessage: 'Send message',
        category: 'Category',
        chooseCorrectFormat: 'Please choose correct format file',
        close: 'Closed',
        closeFailed: 'Close ticket Failed',
        closeInfo: 'You can reopen the ticket while submitting another ticket.',
        content: 'Content',
        sidebarTitle: 'Content',
        contentNote1: 'Clear and concise request will help us solve your problem quickly.',
        contentNote2:
          'For requests related to lost conversions, wrong conversion information, please include the campaign name, customer info (name, phone number), the time of filling the form, attached images, videos or any other documents if any.',
        createdAt: 'Created at',
        createTitle: 'Ticket info',
        filesSelected: '({totalFiles} choosen file)',
        filesTooLargeTitle: 'Files size too large!',
        filesTooLarge: 'File size too large (>{filesSize}MB)',
        fileWrongType: 'Wrong format',
        limitExceeded: 'File size reached  {filesSize}MB',
        infoClose: 'Please close ticket in case your problem has been resolved.',
        infoReOpen: 'You can still reopen the ticket while submitting another ticket.',
        label: 'Title',
        placeholder: 'Please enter a title',
        messagePlaceholder: 'Enter message ...',
        noFileSelected: 'No chosen file',
        notAllowed: 'Ticket unavailable',
        notFound: 'Ticket not found',
        noticeBeforeClose: 'Ticket will be closed after {daysLeft}{hoursLeft}.',
        open: 'Opening',
        processing: 'Processing...',
        requiredType: 'Select <b>ticket type</b> first',
        reOpenSuccess: 'Ticket #{ticketID} reopened',
        sendMessageFailed: 'Send message Failed',
        sendSuccess: 'Send message Successful',
        spamMessageWarning: 'Please wait until you get a response from your AM.',
        status: 'Status',
        subTitle: 'Sending tickets only when necessary will help us work more productively',
        tHeadLastUpdated: 'Last updated',
        tHeadStatus: 'Status',
        tHeadTitle: 'Title',
        tHeadCategory: 'Category',
        ticketPlaceholder: 'Enter description...',
        title: 'You have no opening ticket | You have {number} opening ticket | You have {number} opening ticket',
        titleCreate: 'Ticket #{idTicket} - {titleTicket}',
        type: 'Type',
        typeCategory: 'Category',
        updatedAt: 'Last updated',
        wrongType: 'Wrong format!',
        ticketType: 'Select type',
        ticketCategory: 'Select category',
      },
      findConversion: {
        btnRequestFindConversion: 'Send a request',
        filterTitle: 'Request History',
        filterByCampaignId: 'Offer ID',
        filterByProcessStatus: 'Process Status',
        filterByConversionStatus: 'Conversion Status',
        introduce: {
          contentTop: `The problem of losing conversions happens at every Affiliate Network. At HyperLead, we are always listening to Publisher's feedbacks and finding a way to enhance your experience. Hence, HyperLead launched "Find my Conversions" tool for Publisher in order to track the lost conversions.`,
          contentBottom: {
            title: 'Please notice:',
            listContent: {
              content1: '<span>For some reasons, some conversions may be <b>delayed up to 24 hours.</b></span>',
              content2: '<span>Carefully check <b>before input to avoid duplicated request.</b></span>',
              content3: '<span>Your account will be terminated <b>in case fraud info was found.</b></span>'
            }
          },
        },
        processStatus: {
          hyperLeadReceived: 'HyperLead received',
          processing: 'Processing',
          sentToAdvertiser: 'Sent to Advertiser',
          done: 'Done',
        },
        conversionStatus: {
          notStatus: '-',
          cancel: 'Canceled',
          success: 'Success'
        },
        table: {
          requestDate: 'Created Date',
          orderId: 'Order ID',
          campaignId: 'Offer ID',
          customerPhone: 'User phone number',
          processStatus: 'Process Status',
          conversionStatus: 'Conversion status',
          estimateRevenue: 'Commission',
          note: 'Note',
        },
        popup: {
          title: 'Send a request',
          step1: {
            title: '<span><b>Step 1/3:</b> Please select an offer you want to find conversion</span>',
            placeholderCampaign: 'Type or scroll to select an offer',
            msgNoResults: 'No offer found',
            btnContinue: 'Next',
          },
          step2: {
            found: {
              title: '<span><b>Step 2/3:</b> Read carefully the following process and make sure your user finished the flow correctly.</span>',
              processSignUpCampaignTitle: 'Registration Process for',
              btnComeback: 'Back',
              btnContinue: 'Next',
            },
            notFound: {
              message: `Sorry, ”Find my conversions” doesn't support this offer. We will update it soon.`,
              btnFindOtherCampaign: 'Make another request',
              btnExit: 'Close'
            }
          },
          step3: {
            title: '<span><b>Bước 3/3:</b>  Hãy nhập thông tin yêu cầu tìm lại đơn</span>',
            inputCampaignLabel: 'Offer',
            btnComeback: 'Back',
            btnSendRequest: 'Send!',
            uploadImageLabel: 'Image prove ( optional )',
            btnUploadImage: 'Upload',
            limitRequestNote: '* You can make up to 10000 single lookups per month for this campaign. If you have an urgent processing request with a larger number of orders, please contact Account Manager for the fastest support\n',
            orderWith: 'You want to look up by:',
            singleOrderOffer: 'Look up each order',
            multiPOrderOffer: 'Batch lookup',
            sampleFileNote: 'Download the sample file and fill in the information in the file. Then upload the file and select “Send Request”'
          },
          step4: {
            btnComeback: 'Back',
            btnSendRequest: 'Send',
            limitRequest: 'The number of requests exceeds the allowed number of times, you have {limit} of requests to look up this campaign single today',
            readFileResult: {
              failureTitle: 'UNSUCCESSFUL',
              successTitle: 'File reading results',
              missingField: 'The {column} column is missing from the uploaded file, please add and re-upload',
              onlyCSV: 'Invalid file format, please upload only Excel or CSV file',
              offer: 'Offer: {offer}',
              fileNotValid: 'Column title is wrong format, please check and re-upload',
              valid_offer: 'Valid offer number: {valid_offer}',
              invalid_offer: 'Invalid offer number: {invalid_offer}',
              downloadInvalidOffer: 'Invalid list download',
              offer_not_found: 'Offer does not exist, please check and re-upload',
              file_not_valid: 'The column title is wrong format, please check and re-upload',
              publisher_not_exist: 'Publisher does not exist, please check and re-upload',
              file_max_record: 'Only 10000 lines are allowed in the file, please check and re-upload',

            }
          },
          step5: {
            successTitle: 'SENT SUCCESSFULLY',
            successMessage: `Thank you for providing the info! HyperLead will do the best in checking and updating the result for you.`,
            btnClose: 'Close',
            max_request_per_day: 'The number of requests exceeded the allowed number of times, you have {limit} left of single lookup requests for this offer for this month.'
          },
        },
        noData: 'No data! Please choose again',
        downloading: 'Request successful! Downloading!',
        requestSuccess: 'Request successful! Downloading!',
        sendRequestFailed: 'Your request has failed, please try again.',
      }
    },
    knowledgeBase: {
      knowledgeForPub: 'Basic knowledge',
      subKnowledgeForPub: 'HyperLead answer your questions!',
      searchPost: 'What are you looking for?',
      relatedPosts: 'Related posts',
      noRelatedPost: 'No related post',
      updatedAt: 'Last updated',
    },
    staticPage: {
      err404: '404 - Not found!',
      err404Message:
        "<p>Looks like we  couldn't find what you're looking for.</p><p>The page you visited does not exist or is not available.</p>",
      btnBackToHome: 'Back to homepage',
      thankyou: 'Successful',
      thankyouMessage: '\n                <p>Congrats! You have successfully registered an account at HyperLead.</p>',
      completeTitle: "Completed!",
      completeDesc: "Your password was changed",
      loginNow: "Login",
    },
    termsAndConditions: {
      title: 'Terms & Conditions',
      backToRegister: 'Back to registration page',
    },
    privacyPolicy: {
      title: 'Privacy Policy',
      backToRegister: 'Back to registration page',
    },
    verifyEmail: {
      pleaseVerifyEmail: 'Please',
      verifyEmail: 'verify email',
      toUseAllFeatures: 'to use all features',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/i18nData.js